// en translations — extracted mechanically from LanguageContext.jsx (Team Foundation).
// Feature-specific keys belong in src/i18n/extensions/*.js instead.
const en = {
    // Payouts
    "payouts.title": "Payout Center",
    "payouts.subtitle": "Manage your royalties, earnings, and payout methods.",
    "payouts.withdrawableBalance": "Withdrawable Balance",
    "payouts.totalEarnings": "Total Earnings",
    "payouts.pending": "Pending",
    "payouts.requestPayout": "Request Payout",
    "payouts.createRequest": "Create Payout Request",
    "payouts.requestDesc": "Initiate a transfer to your registered payout method.",
    "payouts.amount": "Amount ($)",
    "payouts.minAmountShort": "Min: $50",
    "payouts.bankTransfer": "Bank Transfer",
    "payouts.paypal": "PayPal",
    "payouts.confirmRequest": "Confirm Request",
    "payouts.completedWithdrawals": "Completed Withdrawals",
    "payouts.totalWithdrawn": "Total Withdrawn",
    "payouts.transactionHistory": "Transaction History",
    "payouts.paymentMethods": "Payout Methods",
    "payouts.recentTransactions": "Recent Transactions",
    "payouts.noTransactions": "No Transactions Yet",
    "payouts.noTransactionsDesc": "Your past payout requests will be listed here.",
    "payouts.statusPaid": "Paid",
    "payouts.statusRequested": "Pending",
    "payouts.noPaymentMethod": "No Payout Method Found",
    "payouts.addMethodDesc": "Add a payout method to withdraw your earnings.",
    "payouts.addMethod": "Add Method",
    "payouts.verified": "Verified",
    "payouts.pendingVerification": "Pending Verification",
    "payouts.changeMethod": "Change Payout Method",
    "payouts.methodDesc": "Enter your payout method details to receive your earnings.",
    "payouts.bank": "Bank",
    "payouts.accountHolder": "Account Holder Name",
    "payouts.bankName": "Bank Name",
    "payouts.ibanOrAccount": "IBAN or Account Number",
    "payouts.swiftBic": "SWIFT/BIC Code",
    "payouts.paypalEmail": "PayPal Email Address",
    "payouts.securityVerification": "Security Verification",
    "payouts.enterVerificationCodeDesc": "Enter the 6-digit code sent to your email to confirm the transaction.",
    "payouts.remainingAttempts": "Remaining attempts:",
    "payouts.sendNewCode": "Send New Code",
    "payouts.deleteMethod": "Delete Method",
    "payouts.deleteMethodConfirm": "Are you sure you want to delete this payout method?",
    
    // Viral Campaign
    "viral.tiktokName": "TikTok Campaign",
    "viral.instagramName": "Instagram Reels",
    "viral.twitterName": "Twitter/X Viral",
    "viral.campaignTitleFallback": "Viral Campaign",
    "viral.campaignDescFallback": "Viral Campaign",
    "viral.day": "Day",
    "viral.activeCampaignsTitle": "Active Campaigns",
    "viral.campaignFallback": "Campaign",
    "viral.activeStatus": "Active",

    // Mastering
    "mastering.presetStreaming": "Streaming (Spotify/Apple)",
    "mastering.presetYoutube": "Video (YouTube)",
    "mastering.presetCD": "CD Master",
    "mastering.presetClub": "Club / EDM",
    "mastering.presetAcoustic": "Acoustic / Jazz",
    "mastering.presetPodcast": "Podcast / Voice",
    "mastering.band": "Band",
    "mastering.loudness": "Loudness",
    "mastering.integratedLufs": "Integrated LUFS",
    "mastering.truePeak": "True Peak",
    "mastering.dynamicRange": "Dynamic Range",
    "mastering.eq": "EQ",
    "mastering.bass": "Bass",
    "mastering.mid": "Mid",
    "mastering.treble": "Treble",
    "mastering.processing": "Processing",
    "mastering.stereoWidth": "Stereo Width",
    "mastering.compression": "Compression",
    "mastering.saturation": "Saturation",
    "mastering.additionalProcessing": "Additional Processing",
    "mastering.deEsser": "De-Esser",
    "mastering.limiterCeiling": "Limiter Ceiling",
    "mastering.aiAnalyzing": "AI Analyzing",
    "mastering.masteringProcessing": "Mastering Processing",
    "mastering.analyzingDesc": "Analyzing audio...",
    "mastering.processingDesc": "Applying mastering...",
    "mastering.brightness": "Brightness",

    // Subscription
    "subscription.freeDesc": "Start your music journey",
    "subscription.artistDesc": "For serious artists",
    "subscription.labelDesc": "For labels and managers",
    "subscription.featFree1": "1 release (lifetime)",
    "subscription.featFree2": "20% commission",
    "subscription.featFree3": "Standard delivery (2-5 days)",
    "subscription.featFree4": "Email support",
    "subscription.featArtist1": "Unlimited uploads",
    "subscription.featArtist2": "0% commission",
    "subscription.featArtist3": "Fast delivery (24-72h)",
    "subscription.featArtist4": "Basic analytics",
    "subscription.featArtist5": "Split system",
    "subscription.featArtist6": "Priority email support",
    "subscription.featLabel1": "Multi-artist management",
    "subscription.featLabel2": "Advanced splits",
    "subscription.featLabel3": "Bulk upload",
    "subscription.featLabel4": "Advanced analytics",
    "subscription.featLabel5": "Fast distribution",
    "subscription.featLabel6": "Priority support",

    // Common
    "common.loading": "Loading...",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.submit": "Submit",
    "common.back": "Back",
    "common.next": "Next",
    "common.previous": "Previous",
    "common.search": "Search",
    "common.filter": "Filter",
    "common.all": "All",
    "common.yes": "Yes",
    "common.no": "No",
    "common.logout": "Logout",
    "common.login": "Login",
    "common.register": "Register",
    
    // Auth
    "auth.welcome": "Welcome",
    "auth.signIn": "Sign in to your account",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.loginButton": "Sign In",
    "auth.noAccount": "Don't have an account? Register with an invite link.",
    "auth.loginSuccess": "Login successful",
    "auth.loginFailed": "Login failed",

    "auth.loginBtn": "LOG IN",
    "auth.createAccount": "Create Account",
    "auth.firstName": "First Name",
    "auth.lastName": "Last Name",
    "auth.accountType": "Account Type",
    "auth.artist": "Artist",
    "auth.label": "Label",
    "auth.address": "Address",
    "auth.city": "City",
    "auth.country": "Country",
    "auth.postalCode": "Postal Code",
    "auth.phone": "Phone",
    "auth.currency": "Currency",
    "auth.hasAccount": "Already have an account?",
    "auth.registerBtn": "REGISTER",
    "auth.agreeTerms": "I agree to the Terms of Service and Privacy Policy",
    "auth.registerSubtitle": "Join the music distribution platform",
    "auth.individualArtist": "Individual artist",
    "auth.recordLabel": "Record label",
    "auth.labelInformation": "Label Information",
    "auth.labelName": "Label Name",
    "auth.labelDescription": "Label Description",
    "auth.website": "Website",
    "auth.instagram": "Instagram",
    
    // Navigation
    "nav.dashboard": "Dashboard",
    "nav.releases": "Releases",
    "nav.payouts": "Payouts",
    "nav.support": "Support",
    "nav.help": "Help & Guides",
    "nav.analytics": "Analytics",
    "nav.referrals": "Referrals",
    "nav.subscription": "Subscription",
    "nav.splits": "Revenue Splits",
    "nav.promotions": "Promotions",
    "nav.profile": "Profile",
    "nav.playlistExplorer": "Playlist Explorer",
    "nav.aiMatcher": "AI Matcher",
    "nav.campaigns": "Campaigns",
    "nav.bioLink": "Bio Link",
    "nav.canvasStudio": "Canvas Studio",
    "nav.aiVideo": "AI Video",
    "nav.viralCampaign": "Viral Campaign",
    "nav.aiStudio": "AI Studio",
    "nav.aiMastering": "AI Mastering",
    "nav.mixMastering": "Mix Mastering",
    "nav.lyricsManager": "Lyrics Manager",
    "nav.contributors": "Contributors",
    "nav.aiAdvisor": "AI Advisor",
    "nav.connections": "Connections",
    "nav.preSave": "Pre-Save",
    "nav.smartLinks": "Smart Links",
    "nav.qrCodes": "QR Codes",
    "nav.collaborations": "Collaborations",
    "nav.lyricsSync": "Lyrics Sync",
    "nav.section.music": "Music",
    "nav.section.discover": "Discover",
    "nav.section.promotion": "Promotion",
    "nav.section.aiStudio": "AI Studio",
    "nav.section.career": "Career",
    "nav.section.finance": "Finance",
    "nav.section.growth": "Growth",
    "nav.section.marketing": "Marketing",
    "nav.section.tools": "Tools",
    "nav.section.community": "Community",
    "nav.section.support": "Support",
    "nav.logout": "Log Out",
    "nav.comingSoon": "Beta",
    "notifications.markAllRead": "Mark all read",
    "notifications.empty": "No notifications",
    
    // Dashboard
    "dashboard.welcome": "Welcome",
    "dashboard.subtitle": "Manage your music, track your releases and view your earnings.",
    "dashboard.totalReleases": "Total Releases",
    "dashboard.totalTracks": "Total Tracks",
    "dashboard.balance": "Current Balance",
    "dashboard.withdrawable": "Withdrawable",
    "dashboard.recentReleases": "Recent Releases",
    "dashboard.viewAll": "View All",
    "dashboard.topTracks": "Top Tracks",
    "dashboard.recentActivities": "Recent Activities",

    "dashboard.viewDetails": "View Details",
    "dashboard.viewAnalytics": "View Analytics",
    "upload.status": "Upload Status",
    "upload.none": "No Uploads",
    "upload.noneDesc": "There is currently no ongoing upload.",
    "auth.pendingApproval": "Pending Approval",
    "auth.pendingApprovalDesc": "Your account is pending admin approval. You will be able to access the portal once approved.",
    "auth.accountApproved": "Your account has been approved!",
    "auth.accountRejected": "Your account has been rejected.",
    "auth.accountPendingInfo": "Your account is still pending approval.",
    "auth.invalidResetLink": "Invalid password reset link",
    "auth.passwordLengthError": "Password must be at least 6 characters",
    "auth.passwordsDoNotMatch": "Passwords do not match",
    "auth.passwordChangedSuccess": "Your password has been changed successfully!",
    "auth.passwordResetFailed": "Password reset failed",
    "auth.passwordChanged": "Password Changed!",
    "auth.passwordChangedDesc": "Your password has been successfully updated. You can login with your new password.",
    "auth.goToLogin": "Go to Login Page",
    "auth.setNewPassword": "Set New Password",
    "auth.setNewPasswordDesc": "Create a new password for your account.",
    "auth.newPassword": "New Password",
    "auth.confirmPassword": "Confirm Password",
    "auth.changePassword": "Change Password",
    "releases.release": "Release",
    "releases.artist": "Artist",
    "releases.status": "Status",
    "releases.date": "Date",
    "releases.actions": "Actions",
    "releases.deleteRelease": "Delete",
    "releases.noSearchMatch": "No releases match your search criteria. Please try different keywords.",
    "releases.createFirst": "Create your first music release and share it with your listeners on all platforms.",
    "releases.deleteReleaseConfirm": "Are you sure you want to delete the release '{releaseName}'?",
    "releases.cannotBeUndone": "This action cannot be undone.",
    "metadata.copied": "{label} copied!",
    "metadata.copyFailed": "Copy failed",
    "metadata.copy": "Copy",
    "metadata.downloaded": "{label} downloaded!",
    "metadata.downloadFailed": "Download failed",
    "metadata.dspCopied": "DSP summary copied to clipboard!",
    "metadata.copyDsp": "Copy DSP Summary",
    "metadata.noAudio": "Audio file not uploaded",
    "metadata.noCover": "Cover art not uploaded",
    "dashboard.drafts": "Drafts",
    "dashboard.untitled": "Untitled Release",
    "dashboard.noGenre": "No genre",
    "dashboard.clickToEdit": "Click to continue editing",
    "dashboard.newRelease": "Create New Release",
    "dashboard.newReleaseDesc": "Share your music with the world",
    "dashboard.requestPayout": "Request Payout",
    "dashboard.noReleases": "No releases yet",
    "dashboard.createFirst": "Create your first release to get started.",
    "dashboard.greetingMorning": "Good morning",
    "dashboard.greetingAfternoon": "Good afternoon",
    "dashboard.greetingEvening": "Good evening",
    "dashboard.artist": "Artist",
    "dashboard.lastLogin": "Last login",
    "dashboard.today": "Today",
    "dashboard.range7d": "7D",
    "dashboard.range30d": "30D",
    "dashboard.range90d": "90D",
    "dashboard.range1y": "1Y",
    "dashboard.rangeAll": "All",
    "dashboard.income": "Income",
    "dashboard.liveReleases": "Live Releases",
    "dashboard.last30days": "last 30 days",
    "dashboard.liveStreamingMap": "Live Streaming Map",
    "dashboard.live": "Live",
    "dashboard.noDataYet": "No data yet",
    "dashboard.streams": "streams",
    "dashboard.wentLive": "Went live",
    "dashboard.rejected": "Rejected",
    "dashboard.inReview": "In review",
    "dashboard.revenueAnalysis": "Revenue Analysis",
    "dashboard.platformFilter": "Platform Filter",
    "dashboard.totalRevenue": "Total Revenue",
    "dashboard.welcomeBack": "Welcome back",
    "dashboard.searchPlaceholder": "What do you want to do?",
    "dashboard.totalEarnings": "Total Earnings",
    "dashboard.availableBalance": "Available Balance",
    "dashboard.artistNetPay": "Net pay after splits",
    "dashboard.period6m": "6 Mo",
    "dashboard.period1y": "1 Year",
    "dashboard.periodAll": "All",
    "dashboard.noEarnings": "No earnings yet",
    "dashboard.noEarningsDesc": "Your earnings will be displayed here when added.",
    "dashboard.setupTitle": "Complete Account Setup",
    "dashboard.stepProfile": "Complete artist profile",
    "dashboard.stepProfileDesc": "Add your name, genre, and connect platforms",
    "dashboard.stepPayoutProfile": "Verify payout profile",
    "dashboard.stepPayoutProfileDesc": "Complete your information to receive payments",
    "dashboard.stepPayment": "Add payment method",
    "dashboard.stepPaymentDesc": "Add a bank or PayPal account",
    "dashboard.stepRelease": "Upload first release",
    "dashboard.stepReleaseDesc": "Share your music with the world",
    "dashboard.stepConnections": "Connect platforms",
    "dashboard.stepConnectionsDesc": "Link social media and music platforms",
    "dashboard.notifications": "Notifications",
    "dashboard.noNotifications": "No notifications",
    "dashboard.whatsHappening": "What's Happening?",
    "dashboard.supportTickets": "Support Tickets",
    "dashboard.newTicket": "New Ticket",
    "dashboard.noTickets": "No open support tickets",
    "dashboard.noTicketsDesc": "You can create a new ticket when you need help.",
    "dashboard.ticketOpen": "Open",
    "dashboard.ticketPending": "Pending",
    "dashboard.ticketWaiting": "Awaiting Response",
    "dashboard.ticketResolved": "Resolved",
    "dashboard.ticketClosed": "Closed",
    "dashboard.learnMore": "Learn More",
    "dashboard.sectionError": "Failed to load data",
    "dashboard.retry": "Retry",
    "dashboard.justNow": "Just now",
    "dashboard.minAgo": "min ago",
    "dashboard.hrsAgo": "hrs ago",
    "dashboard.yesterday": "Yesterday",
    "dashboard.daysAgo": "days ago",
    "dashboard.catPlatform": "Platform",
    "dashboard.catDSP": "DSP News",
    "dashboard.catCampaign": "Campaign",
    "dashboard.catEducation": "Education",
    "dashboard.catGeneral": "General",
    
    // Layout
    "layout.profile": "Profile",
    "layout.subscription": "Subscription",
    "layout.logout": "Logout",
    
    // QR Code Generator
    "qr.title": "QR Code Generator",
    "qr.create": "Create QR Code",
    "qr.createTitle": "New QR Code",
    "qr.url": "URL",
    "qr.qrTitle": "Title",
    "qr.fgColor": "Foreground Color",
    "qr.bgColor": "Background Color",
    "qr.size": "Size",
    "qr.small": "Small",
    "qr.medium": "Medium",
    "qr.large": "Large",
    "qr.download": "Download",
    "qr.delete": "Delete",
    "qr.scanCount": "Scans",
    "qr.empty": "No QR codes yet",
    "qr.emptyDesc": "Create your first QR code to get started.",
    
    // Smart Links
    "smartLinks.title": "Smart Links",
    "smartLinks.subtitle": "Create smart redirect pages for your music",
    "smartLinks.createBtn": "Create Smart Link",
    "smartLinks.cover": "Cover",
    "smartLinks.backgroundImage": "Background Image",
    "smartLinks.cancel": "Cancel",
    "smartLinks.create": "Create Smart Link",
    "smartLinks.linkTitle": "Title",
    "smartLinks.slug": "Custom URL Slug",
    "smartLinks.platforms": "Platform Links",
    "smartLinks.clicks": "Clicks",
    "smartLinks.copy": "Copy Link",
    "smartLinks.copied": "Copied!",
    "smartLinks.empty": "No smart links yet",
    "smartLinks.emptyDesc": "Create your first smart link to share your music.",
    
    // Pre-Save Campaign
    "preSave.title": "Pre-Save Campaigns",
    "preSave.subtitle": "Create pre-save campaigns for your upcoming releases",
    "preSave.createNew": "New Campaign",
    "preSave.createBtn": "Create Campaign",
    "preSave.descPlaceholder": "Campaign description...",
    "preSave.backgroundImage": "Background Image",
    "preSave.uploadBg": "Upload Background",
    "preSave.bgHint": "Recommended: 1920x1080px landscape image",
    "preSave.cancel": "Cancel",
    "preSave.all": "All",
    "preSave.pending": "Pending",
    "preSave.approved": "Approved",
    "preSave.rejected": "Rejected",
    "preSave.create": "Create Campaign",
    "preSave.selectRelease": "Select Release",
    "preSave.releaseDate": "Release Date",
    "preSave.description": "Description",
    "preSave.saves": "Saves",
    "preSave.daysLeft": "days left",
    "preSave.released": "Released",
    "preSave.active": "Active",
    "preSave.copy": "Copy Link",
    "preSave.empty": "No pre-save campaigns yet",
    "preSave.emptyDesc": "Create a pre-save campaign for your upcoming release.",
    
    // Email Marketing
    "email.title": "Email Marketing",
    "email.subscribers": "Subscribers",
    "email.campaigns": "Campaigns",
    "email.addSubscriber": "Add Subscriber",
    "email.name": "Name",
    "email.emailAddr": "Email Address",
    "email.subject": "Subject",
    "email.template": "Template",
    "email.content": "Content",
    "email.send": "Send",
    "email.draft": "Draft",
    "email.sent": "Sent",
    "email.opened": "Opened",
    "email.clicked": "Clicked",
    "email.import": "Import CSV",
    "email.export": "Export CSV",
    "email.empty": "No data yet",
    "email.totalSubscribers": "Total Subscribers",
    
    // Social Media Scheduler
    "social.title": "Social Media Scheduler",
    "social.newPost": "New Post",
    "social.content": "Content",
    "social.platforms": "Platforms",
    "social.schedule": "Schedule",
    "social.draft": "Draft",
    "social.scheduled": "Scheduled",
    "social.published": "Published",
    "social.edit": "Edit",
    "social.delete": "Delete",
    "social.calendar": "Calendar",
    "social.list": "List",
    "social.empty": "No posts yet",
    "social.emptyDesc": "Plan and schedule your social media posts.",
    
    // Press Kit
    "pressKit.title": "Press Kit (EPK)",
    "pressKit.bio": "Biography",
    "pressKit.photos": "Photos",
    "pressKit.discography": "Discography",
    "pressKit.social": "Social Links",
    "pressKit.contact": "Contact Info",
    "pressKit.save": "Save Press Kit",
    "pressKit.preview": "Preview",
    "pressKit.publicUrl": "Public URL",
    "pressKit.empty": "Your press kit is empty",
    
    // Lyrics Sync
    "lyricsSync.title": "Lyrics Sync",
    "lyricsSync.subtitle": "Create time-synced lyrics for your tracks",
    "lyricsSync.lyricsEditor": "Lyrics Editor",
    "lyricsSync.resetTimestamps": "Reset Timestamps",
    "lyricsSync.tapToSync": "Tap to Sync",
    "lyricsSync.timestamps": "Timestamps",
    "lyricsSync.save": "Save Lyrics",
    "lyricsSync.synced": "Synced",
    "lyricsSync.selectTrack": "Select Track",
    "lyricsSync.lyrics": "Lyrics",
    "lyricsSync.sync": "Sync",
    "lyricsSync.tap": "Tap to Sync",
    "lyricsSync.preview": "Preview",
    "lyricsSync.export": "Export LRC",
    "lyricsSync.save": "Save",
    "lyricsSync.empty": "Select a track to get started",
    
    // Collaborations
    "collab.title": "Collaborations",
    "collab.subtitle": "Invite other artists and collaborate on projects",
    "collab.received": "Received",
    "collab.sent": "Sent",
    "collab.reject": "Reject",
    "collab.create": "New Project",
    "collab.invite": "Invite",
    "collab.projects": "My Projects",
    "collab.invitations": "Invitations",
    "collab.accept": "Accept",
    "collab.decline": "Decline",
    "collab.notes": "Notes",
    "collab.status": "Status",
    "collab.empty": "No collaborations yet",
    "collab.emptyDesc": "Start a collaboration project with other artists.",
    "collab.send_invite": "Invite Artist",
    "collab.email": "Search by name or email",
    "collab.type": "Collaboration Type",
    "collab.type_featured": "Feat. Artist",
    "collab.type_producer": "Producer",
    "collab.type_writer": "Writer",
    "collab.type_remix": "Remix",
    "collab.message": "Message",
    "collab.send": "Send Invitation",
    "collab.no_received": "No collaborations yet",
    "collab.no_sent": "No collaborations yet",
    "collab.invite_success": "Invitation sent successfully!",
    "collab.invite_error": "Could not send invitation",
    "collab.accepted": "Accepted",
    "collab.rejected": "Rejected",
    "collab.respond_error": "Could not respond to invitation",
    "collab.delete_confirm": "Are you sure you want to delete this?",
    "collab.delete_success": "Collaboration deleted",
    "collab.delete_error": "Could not delete collaboration",
    "collab.error_fetch": "Could not load collaborations",
    "collab.status_accepted": "Active",
    "collab.status_rejected": "Rejected",
    "collab.status_pending": "Pending",
    
    // Notification translations

    "notif.release_status.title": "Release Status Update",
    "notif.release_status.approved.title": "Release Approved",
    "notif.release_status.approved.message": "Your release has been approved.",
    "notif.release_status.rejected.title": "Release Rejected",
    "notif.release_status.rejected.message": "Your release has been rejected.",
    "notif.release_status.live.title": "Release Live",
    "notif.release_status.live.message": "Your release has been live.",
    "notif.release_status.needs_edits.title": "Edit Required",
    "notif.release_status.needs_edits.message": "Your release needs some edits before it can be approved.",
    "notif.release_status.in_review.title": "Release In Review",
    "notif.release_status.in_review.message": "Your release is being reviewed.",
    "notif.release_status.taken_down.title": "Release Taken Down",
    "notif.release_status.taken_down.message": "Your release has been taken down.",
    "notif.release_deleted.title": "Release Removed",
    "notif.release_deleted.message": "A release has been removed.",
    "notif.account_status.title": "Account Status",
    "notif.account_status.approved.title": "Account Approved",
    "notif.account_status.rejected.title": "Account Rejected",
    "notif.referral_bonus.title": "Referral Bonus Received!",
    "notif.referral_bonus.message": "You received a referral bonus.",
    "notif.payout_status.title": "Payout Update",
    "notif.payout_status.approved.title": "Payout Approved",
    "notif.payout_status.rejected.title": "Payout Rejected",
    "notif.payout_status.completed.title": "Payout Completed",
    "notif.payout_status.message": "Your payout request has been updated.",
    "notif.ticket_reply.title": "New Support Reply",
    "notif.ticket_reply.message": "You have a new reply on your support ticket.",
    "notif.announcement.title": "New Announcement",
    "notif.spotify_linked.title": "Spotify Profile Linked",
    "notif.spotify_linked.message": "Your artist profile has been linked to Spotify. Statistics are now available.",
    "notif.artist_needs_spotify.title": "Artist Needs Spotify Link",
    "notif.split_response.title": "Split Response",
    "notif.split_response.accepted": "accepted",
    "notif.split_response.rejected": "rejected",
    "notif.revenue_added.title": "Revenue Added",
    "notif.kyc_submission.title": "New KYC Submission",
    "notif.kyc_review.title": "Identity Verification",
    "notif.kyc_review.approved.message": "Your identity verification has been approved!",
    "notif.kyc_review.rejected.message": "Your identity verification was rejected.",
    "notif.playlist_campaign.title": "New Playlist Application",
    "notif.playlist_campaign_approved.title": "Playlist Application Approved",
    "notif.playlist_campaign_approved.message": "Your playlist application has been approved.",
    "notif.playlist_campaign_rejected.title": "Playlist Application Rejected",
    "notif.playlist_campaign_rejected.message": "Your playlist application has been rejected.",
    "notif.reason": "Reason",

        // Fan Engagement
    "fanScore.title": "Fan Engagement",
    "fanScore.subtitle": "Track your audience engagement and growth metrics",
    "fanScore.overall": "Overall Score",
    "fanScore.streaming": "Streaming",
    "fanScore.social": "Social Reach",
    "fanScore.loyalty": "Fan Loyalty",
    "fanScore.activity": "Content Activity",
    "fanScore.trend": "Weekly Trend",
    "fanScore.last12weeks": "Last 12 weeks",
    "fanScore.now": "Now",
    "fanScore.platforms": "Platform Breakdown",
    "fanScore.platformHint": "Score by streaming platform",
    "fanScore.tips": "AI Recommendations",
    "fanScore.noData": "No engagement data available yet.",
    "fanScore.noDataHint": "Release music and grow your audience to see your score.",
    
    // Copyright Scan
    "copyright.title": "Copyright Scan",
    "copyright.newScan": "New Scan",
    "copyright.upload": "Upload File",
    "copyright.selectTrack": "Select Track",
    "copyright.scanning": "Scanning...",
    "copyright.clean": "Clean",
    "copyright.warning": "Warning",
    "copyright.flagged": "Flagged",
    "copyright.matches": "Matches",
    "copyright.similarity": "Similarity",
    "copyright.empty": "No scans yet",
    "copyright.emptyDesc": "Scan your tracks for potential copyright issues.",
    
    // Releases
    "releases.title": "Releases",
    "releases.createNew": "New Release",
    "releases.noReleases": "No releases yet",
    "releases.searchPlaceholder": "Search releases...",
    "releases.localTime": "Local",
    "releases.globalTime": "Global",
    "releases.records": "records",
    "releases.allReleases": "All Releases",
    "releases.drafts": "Drafts",
    "releases.filter": "Filter",
    "releases.sort": "Sort",
    "releases.newest": "Newest",
    "releases.oldest": "Oldest",
    "releases.nameAZ": "Name (A-Z)",
    "releases.nameZA": "Name (Z-A)",
    "releases.inReview": "In Review",
    "releases.approved": "Approved",
    "releases.scheduled": "Scheduled",
    "releases.live": "Live",
    "releases.tableTitle": "Title",
    "releases.tableTracks": "Tracks",
    "releases.tableArtist": "Artist",
    "releases.tableLastUpdate": "Last Update",
    "releases.tableProgress": "Progress",
    "releases.tableActions": "Actions",
    "releases.releaseDate": "Release Date",
    "releases.untitled": "Untitled Release",
    
    // Analytics
    "analytics.title": "Analytics",
    "analytics.subtitle": "Track your releases performance",
    "analytics.totalStreams": "Total Streams",
    "analytics.listeners": "Listeners",
    "analytics.estimatedEarnings": "Estimated Earnings",
    "analytics.monthlyGrowth": "Monthly Growth",
    "analytics.streamsChart": "Streams Chart",
    "analytics.platformDistribution": "Platform Distribution",
    "analytics.topTracks": "Top Tracks",
    "analytics.trackName": "Track Name",
    "analytics.streams": "streams",
    "analytics.comingSoonTitle": "Coming Very Soon",
    "analytics.comingSoonDesc": "Detailed analytics and insights coming soon. With artist.tools integration, you will be able to track all your platform data in one place.",
    "analytics.performance": "Performance",
    "analytics.noDataTitle": "No Analytics Data Yet",
    "analytics.noDataDesc": "Once your releases are tracked on YouTube or Spotify, your statistics will appear here.",
    "analytics.contactAdmin": "Contact admin to link your YouTube videos or Spotify artist profile.",
    "analytics.totalViews": "Total Views",
    "analytics.totalLikes": "Total Likes",
    "analytics.totalComments": "Total Comments",
    "analytics.trackedVideos": "Tracked Videos",
    "analytics.daily": "Daily",
    "analytics.weekly": "Weekly",
    "analytics.topVideos": "Top Performing Videos",
    "analytics.totalFollowers": "Total Followers",
    "analytics.monthlyListeners": "Monthly Listeners",
    "analytics.linkedArtists": "Linked Artists",
    "analytics.avgPopularity": "Avg Popularity",
    "analytics.linkedSpotifyArtists": "Linked Spotify Artists",
    "analytics.followers": "followers",
    "analytics.popularity": "popularity",
    "analytics.advancedTitle": "Advanced Analytics Coming Soon",
    "analytics.advancedDesc": "Detailed stream counts, geographic distribution, and revenue analytics will be available soon.",
    
    // Payouts
    "payouts.title": "Manage Your Earnings",
    "payouts.subtitle": "Easily withdraw your music earnings. Request a payout with a minimum of $50.",
    "payouts.fastPayment": "Fast payment",
    "payouts.secureTransfer": "Secure transfer",
    "payouts.totalBalance": "Total Balance",
    "payouts.withdrawableBalance": "Withdrawable",
    "payouts.requestPayout": "Request Payout",
    "payouts.payoutHistory": "Payout History",
    "payouts.noPayouts": "No payout requests yet",
    "payouts.noPaymentMethod": "No Payment Method",
    "payouts.addMethodDesc": "Add a payment method to withdraw your earnings.",
    "payouts.addMethod": "Add Payment Method",
    "payouts.changeMethodVerification": "Email verification required to change your current payment method",
    "payouts.availableBalance": "Available Balance",
    "payouts.pendingBalance": "Pending Balance",
    "payouts.withdrawalHistory": "Withdrawal History",
    "payouts.requestWithdrawal": "Request Withdrawal",
    "payouts.minWithdrawal": "Minimum withdrawal: $50",
    "payouts.tabProfile": "Payment Profile",
    "payouts.tabMethod": "Payment Method",
    "payouts.tabRequests": "Withdrawal Requests",
    "payouts.requirements": "Requirements for Withdrawal",
    "payouts.completeProfile": "Complete your payment profile (Identity and Address)",
    "payouts.addPaymentMethod": "Add a payment method (Bank or PayPal)",
    "payouts.verifyPaymentMethod": "Verify your payment method",
    "payouts.profileComplete": "Profile Complete",
    "payouts.savedProfile": "Saved Profile Information",
    "payouts.fullName": "Full Name",
    "payouts.phoneNumber": "Phone Number",
    "payouts.location": "Location",
    "payouts.profileType": "Profile Type",
    "payouts.individual": "Individual",
    "payouts.business": "Business / Company",
    "payouts.edit": "Edit",
    "payouts.firstName": "First Name",
    "payouts.lastName": "Last Name",
    "payouts.displayName": "Display Name",
    "payouts.companyName": "Company Name",
    "payouts.selectCountry": "Select your country",
    "payouts.saveProfile": "Save Profile",
    "payouts.saving": "Saving...",
    "payouts.changeMethod": "Change Payment Method",
    "payouts.phoneRequired": "Phone number is required",
    "payouts.operationFailed": "Operation failed",
    "payouts.verificationSent": "Verification code sent to your email",
    "payouts.maxAttemptsReached": "Maximum attempts reached. Please request a new code.",
    "payouts.methodUpdated": "Your payment method has been updated successfully",
    "payouts.verificationFailed": "Verification failed",
    "payouts.newCodeSent": "New verification code sent",
    "payouts.codeSendFailed": "Failed to send code",
    "payouts.weeklyLimitReached": "You have reached your weekly withdrawal limit (2/2). Please try again next week.",
    "payouts.profileMethodRequired": "Profile and payment method must be completed to request a withdrawal",
    "payouts.requestCreated": "Withdrawal request created",
    "payouts.requestFailed": "Withdrawal request failed",
    "payouts.methodSaved": "Payment method saved",
    "payouts.methodDeleted": "Payment method deleted",
    "payouts.paymentComplete": "Your payment has been completed",
    "payouts.paymentApproved": "Your payment has been approved",
    "payouts.transferComplete": "Transfer completed successfully",
    "payouts.bankAccount": "Bank Account",
    "payouts.ibanSwift": "IBAN / Swift",
    "payouts.accountNumber": "Account Number",
    "payouts.enterAccountNumber": "Enter account number",
    "payouts.securityNotice": "Security Notice",
    "payouts.securityNoticeDesc": "All changes to your payment method require email verification (valid for 2 minutes). You can only save one payment method.",
    "payouts.completeProfileFirst": "Complete Profile First",
    "payouts.completeProfileFirstDesc": "You need to complete your payment profile before adding a payment method.",
    "payouts.completeProfileBtn": "Complete Profile",
    "payouts.requirementsNotMet": "Requirements not met",
    "payouts.minBalanceRequired": "Minimum $50 withdrawable balance required.",
    "payouts.completeProfileRequired": "Complete your payment profile.",
    "payouts.addVerifyMethodRequired": "Add and verify your payment method.",
    "payouts.weeklyWithdrawalLimit": "Weekly Withdrawal Limit",
    "payouts.withdrawalsMadeThisWeek": "This week {count} / 2 withdrawals made",
    "payouts.weeklyLimitReachedMsg": "You have reached your weekly withdrawal limit. You can withdraw again next week.",
    "payouts.verified": "Verified",
    "payouts.pendingVerification": "Pending Verification",
    "payouts.change": "Change",
    "payouts.changePaymentMethod": "Change Payment Method",
    "payouts.addPaymentMethod": "Add Payment Method",
    "payouts.deletePaymentMethod": "Delete Payment Method",
    "payouts.deleteMethodConfirm": "Are you sure you want to delete this payment method? This action cannot be undone.",
    "payouts.cancel": "Cancel",
    "payouts.identityInfo": "Identity Information",
    "payouts.identityInfoDesc": "Your legal identity information will be used for invoicing and payment compliance",
    "payouts.profileTypeLabel": "Profile Type",
    "payouts.individualOption": "Individual",
    "payouts.individualOptionDesc": "I earn income as an individual",
    "payouts.businessOption": "Business / Company",
    "payouts.businessOptionDesc": "I earn income on behalf of a company",
    "payouts.companyInfo": "Company Information",
    "payouts.companyTitle": "Company Name",
    "payouts.registrationNumber": "Registration Number",
    "payouts.vatNumber": "VAT/Tax Number",
    "payouts.legalFirstName": "Legal First Name",
    "payouts.legalLastName": "Legal Last Name",
    "payouts.displayNameOptional": "Display Name (Optional)",
    "payouts.email": "Email (Account Email)",
    "payouts.emailChangeNote": "Email can be changed from account settings",
    "payouts.addressInfo": "Address Information",
    "payouts.country": "Country",
    "payouts.city": "City",
    "payouts.stateOptional": "State/Region (Optional)",
    "payouts.postalCode": "Postal Code",
    "payouts.addressLine1": "Address Line 1",
    "payouts.addressLine2Optional": "Address Line 2 (Optional)",
    "payouts.taxInfo": "Tax Information",
    "payouts.taxRequired": "Required for withdrawals",
    "payouts.taxInfoDesc": "You must complete your tax information to request a withdrawal",
    "payouts.taxStatus": "Tax Status",
    "payouts.taxStatusPersonal": "Personal Tax ID",
    "payouts.taxStatusCompany": "Company / Tax ID",
    "payouts.taxStatusRequired": "You must select a tax status to request a withdrawal",
    "payouts.taxIdCompany": "Tax ID Number",
    "payouts.taxIdPersonal": "Personal ID Number",
    "payouts.taxCountry": "Tax Country",
    "payouts.savedTaxId": "Saved",
    "payouts.fullAddress": "Full Address",
    "payouts.taxInfoDisplay": "Tax Information",
    "payouts.companyTax": "Company",
    "payouts.personalTax": "Individual",
    "payouts.profileIncomplete": "Profile Incomplete",
    "payouts.profileIncompleteDesc": "Please complete the required fields",
    "payouts.paymentCurrency": "Payment Currency",
    "payouts.paymentCurrencyDesc": "Select which currency you want to receive payments in",
    "payouts.paypalEmailRequired": "PayPal Email Address",
    "payouts.paymentToAccount": "Payment Account",
    "payouts.requestRejected": "Your withdrawal request was rejected",
    "payouts.rejectionReason": "Reason",
    "payouts.paymentCompleteMsg": "Your payment has been completed",
    "payouts.paymentApprovedMsg": "Your payment has been approved",
    "payouts.transferCompleteMsg": "Transfer completed successfully",
    "payouts.paymentInProgress": "Will arrive at your bank in 2-3 business days",
    "payouts.nameAndSurnameRequired": "First name and last name are required",
    "payouts.addressRequired": "Address information is required (Country, City, Postal Code, Address)",
    "payouts.profileSaved": "Payment profile saved",
    "payouts.profileSaveFailed": "Failed to save profile",
    "payouts.accountHolderCountryRequired": "Account holder name and country are required",
    "payouts.bankNameRequired": "Bank name is required",
    "payouts.swiftRequired": "SWIFT/BIC code is required",
    "payouts.ibanRequired": "IBAN is required",
    "payouts.accountNumberRequired": "Account number is required",
    "payouts.paypalEmailRequiredMsg": "PayPal email address is required",
    "payouts.withdrawRequestFailed": "Profile and payment method must be completed to request a withdrawal",
    "payouts.minWithdrawalAmount": "Minimum withdrawal amount is $50",
    "payouts.insufficientBalanceMsg": "Insufficient balance",
    "payouts.withdrawRequestCreated": "Withdrawal request created",
    "payouts.withdrawRequestFailedMsg": "Withdrawal request failed",
    "payouts.enterVerificationCode": "Enter the 6-digit verification code",
    "payouts.selectCountryPlaceholder": "Select a country",
    
    // Wizard extras
    "wizard.editRelease": "Edit Release",
    "wizard.newSingleRelease": "New Single Release",
    "wizard.completeSectionsToSubmit": "Complete all sections to submit your release",
    "wizard.editAlbum": "Edit Album",
    "wizard.newEpAlbum": "New EP / Album",
    "wizard.completeSectionsToSubmitAlbum": "Complete all sections to submit your album",
    "wizard.sections.albumInfo": "Album Info",
    "wizard.sections.tracks": "Tracks",
    "wizard.sections.releaseSettings": "Release Settings",
    "wizard.sections.moreOptions": "More Options",
    "wizard.sections.review": "Review",
    "wizard.selectPRO": "Select PRO",
    
    // Album wizard specific
    "wizard.album.title": "Album Title",
    "wizard.album.titlePlaceholder": "Enter album title",
    "wizard.album.titleRequired": "Album title is required",
    "wizard.album.titleLanguage": "Title Language",
    "wizard.album.version": "Version",
    "wizard.album.versionPlaceholder": "e.g., Deluxe Edition",
    "wizard.album.primaryGenre": "Primary Genre",
    "wizard.album.subGenre": "Sub-Genre",
    "wizard.album.selectGenre": "Select genre",
    "wizard.album.selectSubGenre": "Select sub-genre first",
    "wizard.album.genreRequired": "Primary genre is required",
    "wizard.album.primaryArtists": "Primary Artists",
    "wizard.album.addArtist": "Add artist",
    "wizard.album.artistRequired": "At least one primary artist is required",
    "wizard.album.recordLabel": "Record Label",
    "wizard.album.recordLabelPlaceholder": "Record label name (optional)",
    "wizard.album.coverArt": "Cover Art",
    "wizard.album.coverRequired": "Cover art is required",
    "wizard.album.coverRequirements": "Cover Requirements",
    "wizard.album.squareFormat": "Square format (1:1 ratio)",
    "wizard.album.minResolution": "Minimum 1400x1400 pixels (3000x3000 recommended)",
    "wizard.album.maxFileSize": "Maximum 20MB",
    "wizard.album.jpgPng": "JPG or PNG format",
    "wizard.album.uploadCover": "Upload Cover Art",
    "wizard.album.uploading": "Uploading...",
    "wizard.album.distribution": "Distribution",
    "wizard.album.newRelease": "New Release",
    "wizard.album.newReleaseDesc": "This is a brand new release",
    "wizard.album.transfer": "Transfer from Another Distributor / Previously Released",
    "wizard.album.transferDesc": "This content was previously released through another distributor",
    "wizard.album.existingUpc": "Existing UPC Code",
    "wizard.album.upcPlaceholder": "Enter existing UPC",
    "wizard.album.originalReleaseDate": "Original Release Date",
    "wizard.album.minTracks": "EP/Album requires at least 2 tracks",
    "wizard.album.addTrack": "Add Track",
    "wizard.album.untitled": "Untitled Album",
    "wizard.album.errorsFound": "Errors Found",
    "wizard.album.fixErrors": "Fix Errors",
    "wizard.album.readyToSubmit": "Album Ready to Submit",
    "wizard.album.allComplete": "All sections are complete. Your album is ready to be submitted for review.",
    "wizard.album.submitAlbum": "Submit Album",
    "wizard.album.saveDraft": "Save Draft",
    "wizard.album.errorsDetected": "Errors Detected",
    "wizard.album.fixBeforeSubmit": "You need to fix the following errors before submitting your album:",
    "wizard.album.loadFailed": "Failed to load album",
    "wizard.album.distributionPlatforms": "Distribution Platforms",
    
    // Track related
    "wizard.track.title": "Track Title",
    "wizard.track.titlePlaceholder": "Enter track title",
    "wizard.track.titleRequired": "Track title is required",
    "wizard.track.titleLanguage": "Title Language",
    "wizard.track.trackLanguage": "Track Language",
    "wizard.track.languageDesc": "Language of the lyrics or vocals",
    "wizard.track.version": "Version",
    "wizard.track.versionPlaceholder": "e.g., Deluxe Edition, Acoustic, Remix",
    "wizard.track.versionDesc": "Version info like Acoustic, Live, Remix",
    "wizard.track.primaryGenre": "Primary Genre",
    "wizard.track.subGenre": "Sub-Genre",
    "wizard.track.primaryArtists": "Primary Artists",
    "wizard.track.featuredArtists": "Featured Artists",
    "wizard.track.add": "Add",
    "wizard.track.explicit": "Explicit Content",
    "wizard.track.explicitNone": "None",
    "wizard.track.explicitYes": "Yes, contains explicit content",
    "wizard.track.explicitCleaned": "Cleaned version",
    "wizard.track.isRadioEdit": "Radio Edit",
    "wizard.track.radioEditDesc": "Shortened or edited for radio play",
    "wizard.track.instrumental": "Instrumental",
    "wizard.track.instrumentalDesc": "Contains no vocals",
    "wizard.track.isrcCode": "ISRC Code",
    "wizard.track.useExistingIsrc": "Use Existing ISRC",
    "wizard.track.isrcPlaceholder": "e.g., USRC11234567",
    "wizard.track.audioFile": "Audio File",
    "wizard.track.audioRequired": "Audio file is required",
    "wizard.track.uploadAudio": "Upload Audio File",
    "wizard.track.audioFormats": "WAV or FLAC • 44.1-96kHz • 16/24 bit",
    "wizard.track.recordLabel": "Record Label",
    "wizard.track.albumRecordLabel": "Same record label is used across the album. Change it in track 1.",
    "wizard.track.credits": "Credits",
    "wizard.track.songwriters": "Songwriters",
    "wizard.track.addSongwriter": "Add Songwriter",
    "wizard.track.role": "Role",
    "wizard.track.name": "Name",
    "wizard.track.composer": "Composer",
    "wizard.track.lyricist": "Lyricist",
    "wizard.track.composerLyricist": "Composer & Lyricist",
    "wizard.track.contributors": "Contributors",
    "wizard.track.addContributor": "Add Contributor",
    "wizard.track.productionTeam": "Production Team",
    "wizard.track.addProduction": "Add Production Credit",
    "wizard.track.lyrics": "Lyrics",
    "wizard.track.lyricsLanguage": "Lyrics Language",
    "wizard.track.lyricsPlaceholder": "Enter lyrics here...",
    "wizard.track.lyricsOptional": "Lyrics (Optional)",
    "wizard.track.lyricsDesc": "Lyrics can be displayed on DSPs (Apple Music, Spotify, etc.)",
    "wizard.track.licenseRequired": "License Document Required",
    "wizard.track.licenseRequiredDesc": "You must provide a license document for content that contains samples, remixes, or third-party material.",
    "wizard.track.uploadLicense": "Upload License Document",
    "wizard.track.licenseUploaded": "PDF • Uploaded",
    "wizard.track.unknownArtist": "Unknown Artist",
    
    // Review section
    "wizard.review.summary": "Review Summary",
    "wizard.review.errorsFound": "Errors Found",
    "wizard.review.fixErrors": "Fix Errors",
    "wizard.review.readyToSubmit": "Ready to Submit",
    "wizard.review.allComplete": "All sections are complete. Your release is ready to be submitted for review.",
    
    // Common wizard
    "wizard.next": "Next",
    "wizard.back": "Back",
    "wizard.previous": "Previous",
    "wizard.saveDraft": "Save Draft",
    "wizard.submitRelease": "Submit Release",
    "wizard.fixLater": "Fix Later (Save Draft)",
    "wizard.fixNow": "Fix Now",
    "wizard.errorsDetected": "{{count}} Errors Detected",
    "wizard.fixErrorsBeforeSubmit": "You need to fix the following errors before submitting your release:",
    "wizard.submit": "Submit",
    "wizard.save": "Save",
    "wizard.cancel": "Cancel",
    "wizard.delete": "Delete",
    "wizard.edit": "Edit",
    "wizard.loading": "Loading...",
    "wizard.selectOption": "Select an option",
    
    // Release Settings Section
    "wizard.releaseSettings.streamingPlatforms": "Streaming Platforms",
    "wizard.releaseSettings.socialPlatforms": "Social Platforms",
    "wizard.releaseSettings.selectAll": "Select All",
    "wizard.releaseSettings.selected": "selected",
    "wizard.releaseSettings.timeSync": "Release Time Sync",
    "wizard.releaseSettings.timeSyncDesc": "Choose how your release will roll out globally",
    "wizard.releaseSettings.localTime": "Local Time (Staggered Release)",
    "wizard.releaseSettings.localTimeDesc": "Releases at midnight (00:00) in each region. Your music goes live as each timezone reaches the release date.",
    "wizard.releaseSettings.globalTime": "Global Time (Simultaneous Release)",
    "wizard.releaseSettings.globalTimeDesc": "Releases at the same time worldwide. Goes live everywhere at a single UTC timestamp.",
    "wizard.releaseSettings.releaseDate": "Release Date",
    "wizard.releaseSettings.releaseDateRequired": "Release Date *",
    "wizard.releaseSettings.releaseTime": "Release Time (UTC)",
    "wizard.releaseSettings.minDaysNotice": "At least 7 days from today",
    
    // More Options Section
    "wizard.moreOptions.publishingRights": "Publishing Rights",
    "wizard.moreOptions.publishingQuestion": "What percentage of publishing rights do you own?",
    "wizard.moreOptions.pub100": "100% - I own all publishing rights",
    "wizard.moreOptions.pub0": "0% - I don't own publishing rights",
    "wizard.moreOptions.pubOther": "Other percentage",
    "wizard.moreOptions.proQuestion": "Are you registered with a PRO/CMO?",
    "wizard.moreOptions.proAffiliation": "PRO / Affiliated Society *",
    "wizard.moreOptions.ipiNumber": "IPI Number *",
    "wizard.moreOptions.ipiPlaceholder": "Enter your IPI number",
    "wizard.moreOptions.youtubeContentId": "YouTube Content ID",
    "wizard.moreOptions.youtubeQuestion": "Do you want to enable YouTube Content ID?",
    "wizard.moreOptions.youtubeYes": "Yes, enable Content ID",
    "wizard.moreOptions.youtubeNo": "No, don't enable",
    "wizard.moreOptions.youtubeDesc": "Content ID allows you to monetize your music on YouTube when others use it in their videos.",
    
    // Review Section
    "wizard.review.errorsFoundCount": "{{count}} Errors Found",
    "wizard.review.fixBeforeSubmit": "Fix the following issues before submitting:",
    "wizard.review.releaseReady": "Release Ready to Submit",
    "wizard.review.allFieldsComplete": "All required fields have been completed.",
    "wizard.review.genre": "Genre",
    "wizard.review.content": "Content",
    "wizard.review.releaseDate": "Release Date",
    "wizard.review.timeMode": "Time Mode",
    "wizard.review.distribution": "Distribution",
    "wizard.review.platforms": "Platforms",
    "wizard.review.distributionPlatforms": "Distribution Platforms",
    "wizard.review.localStaggered": "Local (Staggered)",
    "wizard.review.global": "Global",
    "wizard.review.explicit": "Explicit",
    "wizard.review.clean": "Clean",
    "wizard.review.upcIsrcAssigned": "UPC and ISRC codes will be assigned by admin after submission.",
    "wizard.review.creditsSummary": "Credits Summary",
    "wizard.review.songwriters": "Songwriters",
    "wizard.review.productionTeam": "Production Team",
    "wizard.review.contributors": "Contributors",
    "wizard.review.licensedContent": "Licensed Content",
    "wizard.review.licensedContentYes": "Yes - Contains licensed content",
    "wizard.review.licensedContentNo": "No - Original content only",
    "wizard.review.licenseDocUploaded": "License document uploaded",
    
    // More Options - YouTube confirmations
    "wizard.moreOptions.ownershipConfirmation": "I confirm that I own 100% of the rights to this recording and composition.",
    "wizard.moreOptions.contentIdTerms": "I accept the YouTube Content ID terms and conditions.",
    
    // Additional wizard keys
    "wizard.track.track": "Track",
    "wizard.trackCount": "Track Count",
    "wizard.subgenre": "Subgenre",
    "wizard.track.creditInfo": "Credit Information",
    "wizard.track.songwriterRequired": "At least one songwriter is required",
    "wizard.track.productionRequired": "At least one production team member is required",
    
    // Review section - Publishing & YouTube
    "wizard.review.publishingRightsInfo": "Publishing Rights Info",
    "wizard.review.ownership": "Ownership",
    "wizard.review.publisher": "Publisher",
    "wizard.review.youtubeContentIdEnabled": "YouTube Content ID Enabled",
    "wizard.review.youtubeMonetizeDesc": "Your music will be monetized on YouTube",
    "wizard.review.originalReleaseDate": "Original Release Date",
    "wizard.review.trackList": "Track List",
    "wizard.review.upcAssignedAfterSubmit": "UPC code will be assigned by admin after submission.",
    "wizard.review.documentUploaded": "Document uploaded:",
    "wizard.review.documentMissing": "Document missing",
    
    // Release extras
    "release.untitledTrack": "Untitled Track",
    "release.unknownArtist": "Unknown Artist",
    "release.artistNotSpecified": "Artist not specified",
    
    // Common extras
    "common.draft": "Draft",
    
    // Support
    "support.title": "How Can We Help?",
    "support.subtitle": "The EAM Music team is here to answer your questions and provide the best service. Create a support request and we'll get back to you as soon as possible.",
    "support.responseTime": "Response within 24 hours",
    "support.professional": "Professional support",
    "support.tickets": "Support Tickets",
    "support.createTicket": "Create Ticket",
    "support.noTickets": "No support tickets yet",
    
    // Referrals
    "referrals.title": "Referral Program",
    "referrals.commission5": "5% Commission",
    "referrals.lifetimeEarnings": "Lifetime Earnings",
    "referrals.copiedBtn": "Copied",
    "referrals.copyBtn": "Copy",
    "referrals.invitedUsersDesc": "People you brought to the platform and their status",
    "referrals.subtitle": "Invite your friends to EAM Music and earn 5% commission on their earnings. The more you invite, the more you earn!",
    "referrals.commission": "5% Commission",
    "referrals.lifetime": "Lifetime Earnings",
    "referrals.totalInvites": "Total Invites",
    "referrals.activeReferrals": "Active Referrals",
    "referrals.totalEarnings": "Total Earnings",
    "referrals.yourLink": "Your Referral Link",
    "referrals.yourCode": "Your Referral Code",
    "referrals.copy": "Copy",
    "referrals.copied": "Copied!",
    "referrals.yourLink": "Your Referral Link",
    "referrals.link": "Referral Link",
    "referrals.code": "Referral Code",
    "referrals.invitedUsers": "Invited Users",
    "referrals.startSharing": "Start sharing your referral link to earn!",
    "referrals.registerDate": "Registration Date",
    "referrals.active": "Active",
    "referrals.commission": "5% Commission",
    "referrals.lifetime": "Lifetime Earnings",
    "referrals.activeReferrals": "Active Referrals",
    "referrals.commissionRate": "Commission Rate",
    "referrals.totalReferrals": "Total Referrals",
    "referrals.noReferrals": "No referrals yet",
    "referrals.howItWorksDesc": "💡 Share this link with your friends. You'll earn 5% commission on the earnings of every artist who signs up with your link!",
    "referrals.pending": "Pending",
    
    // Releases
    "releases.myReleases": "My Releases",
    "releases.manageAll": "Manage all your releases",
    "releases.createNew": "New Release",
    "releases.searchPlaceholder": "Search releases...",
    "releases.tracks": "tracks",
    "releases.noResults": "No results found",
    "releases.tryDifferent": "Try different search criteria.",
    "releases.deleteDraft": "Delete Draft",
    "releases.deleteDraftMsg": "This draft release will be permanently deleted. This action cannot be undone.",
    "releases.removeFromQueue": "Remove from Queue",
    "releases.removeFromQueueMsg": "This release will be removed from the review queue. You will need to resubmit it.",
    "releases.takedown": "Takedown Release",
    "releases.takedownMsg": "WARNING: This release will be removed from all stores! This may take up to 7 days.",
    "releases.delete": "Delete Release",
    "releases.deleteMsg": "This release will be deleted.",
    "releases.yesRemove": "Yes, Remove",
    
    // Payouts
    "payouts.title": "Manage Your Earnings",
    "payouts.subtitle": "Easily withdraw your music earnings. You can request payment with minimum $50.",
    "payouts.fastPayment": "Fast payment",
    "payouts.secureTransfer": "Secure transfer",
    "payouts.manageEarnings": "Manage your earnings",
    "payouts.requestPayout": "Request Payout",
    "payouts.createRequest": "Create Payout Request",
    "payouts.amount": "Amount",
    "payouts.withdrawableBalance": "Withdrawable Balance",
    "payouts.accountHolder": "Account Holder Name",
    "payouts.bankName": "Bank Name",
    "payouts.totalBalance": "Total Balance",
    "payouts.payoutHistory": "Payout History",
    "payouts.noPayouts": "No payout requests yet",
    "payouts.minAmount": "Minimum withdrawal amount is $50",
    "payouts.insufficientBalance": "Insufficient balance",
    "payouts.fillRequired": "Please fill all required fields",
    "payouts.requestCreated": "Payout request created",
    "payouts.requestFailed": "Request failed",
    "payouts.minNotMet": "Minimum not met",
    "payouts.minNotMetMsg": "You need at least $50 withdrawable balance to request a payout.",
    "payouts.statusRequested": "Requested",
    "payouts.statusPaid": "Paid",
    "payouts.paymentMethod": "Payment Method",
    "payouts.bankTransfer": "Bank Transfer",
    "payouts.paypalEmail": "PayPal Email",
    "payouts.paypalNote": "Enter the email address associated with your PayPal account",
    "payouts.fillPaypalRequired": "Please enter PayPal email and account holder name",
    "payouts.selectCountry": "Select your country",
    
    // Support
    "support.title": "How Can We Help?",
    "support.subtitle": "Our EAM Music team is here to answer your questions and provide the best service. Create a support request and we'll get back to you shortly.",
    "support.responseTime": "Response within 24 hours",
    "support.professional": "Professional support",
    "support.tickets": "Support Tickets",
    "support.trackTickets": "Track all your support tickets here",
    "support.createTicket": "New Support Ticket",
    "support.subject": "Subject",
    "support.subjectPlaceholder": "Briefly describe your issue",
    "support.category": "Category",
    "support.message": "Message",
    "support.messagePlaceholder": "Describe your issue in detail...",
    "support.noTickets": "No support tickets yet",
    "support.fillAllFields": "Please fill all fields",
    "support.ticketCreated": "Support ticket created",
    "support.ticketFailed": "Failed to create ticket",
    "support.statusOpen": "Open",
    "support.statusPending": "Pending",
    "support.statusWaiting": "Waiting for Response",
    "support.statusResolved": "Resolved",
    "support.statusClosed": "Closed",
    "support.categoryRelease": "Release",
    "support.categoryPayout": "Payout",
    "support.categoryAccount": "Account",
    "support.categoryTechnical": "Technical",
    "support.priorityLow": "Low",
    "support.priorityMedium": "Medium",
    "support.priorityHigh": "High",
    
    // Track Upload
    "track.stepTitle": "Upload Your Song",
    "track.stepSubtitle": "First step: Enter song name and upload audio file",
    "track.songName": "Song Name",
    "track.enterSongName": "Enter song name",
    "track.uploadAfterName": "After entering the song name, you can upload the audio file",
    "track.createAndContinue": "Create Track and Continue",
    "track.tracks": "Tracks",
    "track.addTrack": "Add Track",
    "track.bulkUploadTitle": "Upload Multiple Tracks",
    "track.bulkUploadDesc": "Select multiple audio files at once. Each file will become a separate track with its filename as the title.",
    "track.selectMultipleFiles": "Select Audio Files",
    "track.uploading": "Uploading...",
    "track.addOneByOne": "Add tracks one by one",
    "track.addSingleTrack": "Add Single Track",
    "track.addMoreFiles": "Add Files",
    "track.addManually": "Add Manually",
    "track.epAlbumSubtitle": "Upload multiple audio files for your EP/Album. Each file will create a separate track.",
    "track.audioFormatInfo": "Upload audio file (WAV, MP3, M4A, FLAC, AIFF, WMA) - Recommended: WAV 44.1kHz 16-bit stereo",
    "track.audioRequired": "You cannot proceed to the next step without uploading an audio file!",
    "track.addTrackPrompt": "Add a track",
    "track.song": "Song",
    "track.trackName": "Track Name",
    "track.warnings": "Warnings",
    "track.warning1": "Do not add 'feat.' or feature info to track name",
    "track.warning2": "Do not use version info in parentheses",
    "track.warning3": "Avoid using all capital letters",
    "track.isrcCode": "ISRC Code",
    "track.isrcNote": "If you don't have a code, we will create one for you.",
    "track.audioFile": "Audio File",
    "track.uploading": "Uploading",
    "track.uploadOrDrag": "Upload or drag audio file",
    "track.selectFile": "Select File",
    "track.contentType": "Content Type",
    "track.clean": "Clean",
    "track.explicit": "Explicit",
    "track.songPrice": "Song Price – iTunes & Amazon (USD)",
    "track.priceNote": "Songs longer than 10 minutes will have higher pricing.",
    "track.instrumental": "Instrumental (No Vocals)",
    "track.radioEdit": "Radio Edit",
    "track.guestArtist": "Guest Artist",
    "track.guestArtistNote": "Add guest artist if featured in the song",
    "track.version": "Version",
    "track.versionNote": "Version info like Acoustic, Live, Remix",
    
    // Track - Artists
    "track.primaryArtists": "Primary Artists",
    "track.primaryArtistsNote": "Main artist(s) performing on this track",
    "track.addPrimaryArtist": "Add Primary Artist",
    "track.artistNamePlaceholder": "Artist name",
    "track.featuredArtists": "Featured Artists",
    "track.featuredArtistsNote": "Guest artists featured on this track (will appear as 'feat.')",
    "track.addFeaturedArtist": "Add Featured Artist",
    "track.featuredArtistPlaceholder": "Featured artist name",
    "track.required": "Required",
    
    // Track - Previously Released
    "track.previouslyReleased": "Was this track previously released?",
    "track.originalReleaseDate": "Original Release Date",
    "track.originalReleaseDateNote": "Enter the date when this track was first released",
    "track.preReleaseDate": "Pre-Release Date",
    "track.preReleaseDateNote": "Set a date for pre-release/pre-order availability",
    
    // Track - Credits
    "track.creditsTitle": "Writers, Composers & Producers",
    "track.creditsRequired": "Required for stores",
    "track.creditsWarning": "Tracks cannot be delivered to stores without at least one writer/songwriter!",
    "track.writers": "Writers / Songwriters",
    "track.writersPlaceholder": "John Doe, Jane Smith (separate with comma)",
    "track.writersNote": "People who wrote the lyrics",
    "track.composers": "Composers",
    "track.composersPlaceholder": "John Doe, Jane Smith (separate with comma)",
    "track.composersNote": "People who composed the music/melody",
    "track.producers": "Producers",
    "track.producersPlaceholder": "Producer Name (separate with comma)",
    "track.producersNote": "People who produced the track",
    
    // Track - Lyrics
    "track.lyricsTitle": "Lyrics",
    "track.lyricsLanguage": "Lyrics Language",
    "track.lyrics": "Lyrics",
    "track.lyricsPlaceholder": "Enter the song lyrics here...",
    "track.lyricsNote": "Adding lyrics can help your song get discovered on streaming platforms",
    
    // Track - Licensed Content
    "track.licensedContent": "This track contains licensed content (samples, beats, stock sounds, remixed content, etc.)",
    "track.licensedContentNote": "Make sure you have proper licenses for all sampled or third-party content used in this track.",
    
    // Create Release Page
    "release.editTitle": "Edit Release",
    "release.newTitle": "New Release",
    "release.stepOf": "Step {current} / {total}",
    "release.fetchError": "Could not fetch release information",
    "release.saveError": "Could not save release",
    "release.statusChanged": "Release status changed to 'Needs Edits'. You will need to resubmit after completing your changes.",
    "release.addTrackRequired": "Please add at least one track",
    "release.audioRequired": "You must upload audio files for all tracks",
    "release.fillRequired": "Please fill in required fields",
    "release.maxImages": "Maximum 10 images",
    "release.imageDimensions": "Image must be 3000x3000 pixels. Uploaded: {width}x{height}",
    "release.imageReadError": "Could not read image",
    "release.imageUploaded": "Image uploaded",
    "release.imageUploadError": "Could not upload {filename}",
    "release.imageDeleteError": "Could not delete image",
    "release.trackAddError": "Could not add track",
    "release.trackUpdateError": "Could not update track",
    "release.trackDeleteError": "Could not delete track",
    "release.audioUploaded": "Audio file uploaded",
    "release.audioUploadError": "Could not upload audio file",
    "release.acceptTerms": "Please accept the terms",
    "release.trackCoverRequired": "Track and cover image required",
    "release.missingAudio": "{count} track(s) missing audio files",
    "release.submitted": "Release submitted!",
    "release.submitCancelled": "Submission cancelled",
    "release.submitError": "Could not submit release",
    "release.enterSongName": "Please enter song name",
    "release.trackAdded": "Track added",
    "release.uploading": "Uploading...",
    "release.coverUploading": "Image",
    "release.audioFileUploading": "Audio File",
    "release.back": "Back",
    "release.next": "Next",
    "release.submitRelease": "Submit Release",
    "release.selectTypeTitle": "What would you like to release?",
    "release.selectTypeDesc": "Choose the type of release you want to create",
    "release.singleSong": "Single Song",
    "release.singleSongDesc": "Release a single track with its own cover art. Perfect for standalone singles.",
    "release.epAlbum": "EP / Album",
    "release.epAlbumDesc": "Release multiple tracks with a shared album cover. Ideal for EPs and albums.",
    "release.track": "track",
    "release.tracks": "tracks",
    "release.coverImage": "cover",
    "release.albumCover": "album cover",
    "release.continue": "Continue",
    "release.orContinueDraft": "Or continue from your drafts",
    "release.untitled": "Untitled",
    "release.addFromDrafts": "Add from my drafts",
    "release.selectReleaseType": "Please select a release type",
    "release.singleTrackOnly": "Single releases can only have 1 track",
    "release.albumCoverLabel": "Album Cover (All tracks will use this cover)",
    "release.singleCoverLabel": "Cover Image",
    "release.albumCoverInfo": "Album Cover",
    "release.albumCoverInfoDesc": "This cover image will be used for all tracks in your EP/Album.",
    "release.uploadCover": "Upload Cover",
    "release.coverUploaded": "Cover image uploaded",
    "release.releaseType": "Release Type",
    "release.releaseDate": "Release Date",
    "release.language": "Language",
    "release.mainGenre": "Main Genre",
    "release.selectGenre": "Select genre",
    "release.labelName": "Label Name (Optional)",
    "release.labelPlaceholder": "Record label name",
    "release.upcCode": "UPC Code (Optional)",
    "release.upcNote": "If you don't have a code, we will create one for you.",
    "release.platforms": "Platforms",
    "release.aiCoverTitle": "You can create AI visuals",
    "release.aiCoverSubtitle": "Create unique designs with AI for your cover art",
    "release.coverImportant": "IMPORTANT: Cover image must be exactly 3000x3000 pixels. Other sizes will be rejected.",
    "release.coverWarning": "Platforms reject covers that contain URLs, website names or X (Twitter) names or are low quality. Make sure your image is high quality and does not contain any text.",
    "release.coverOwnership": "You own this image and its content. Using other artists', film companies', record labels' etc. images or logos without permission may result in copyright infringement.",
    "release.coverImages": "Cover Images (Maximum 10)",
    "release.uploadOrDrag": "Upload or Drag",
    "release.imagesUploaded": "{count}/10 images uploaded",
    "release.platformInfo": "If you don't have an artist link, we will create one for you.",
    "release.platformUrlPlaceholder": "Enter your platform profile URLs (optional).",
    "release.leaveEmpty": "Leave empty if you don't have an artist link, we will create one for you.",
    "release.almostDone": "Almost done!",
    "release.previewDetails": "Preview release details",
    "release.releaseInfo": "Release Information",
    "release.releaseTypeLabel": "Release Type",
    "release.releaseDateLabel": "Release Date",
    "release.mainGenreLabel": "Main Genre",
    "release.languageLabel": "Language",
    "release.coverLabel": "Cover",
    "release.trackLabel": "Track",
    "release.imagesText": "images",
    "release.songsText": "songs",
    "release.platformsDistribute": "Platforms to Distribute",
    "release.tracksTitle": "Tracks",
    "release.audioUploadedStatus": "Audio uploaded",
    "release.audioMissingStatus": "Audio missing",
    "release.looksGood": "Looks good?",
    "release.confirmBelow": "Confirm the items below to submit your release",
    "release.importantConfirms": "Important Confirmations",
    "release.confirm1": "The content of my release is 100% original. I am the owner of my music, lyrics, composition and cover art.",
    "release.confirm2": "I did not use AI to clone or imitate someone else's voice without permission.",
    "release.confirm3": "All information I entered is accurate and I accept any issues that may arise from errors.",
    "release.confirm4": "I will not use bots, fake streams, artificial listening or any manipulation methods. I know that such activity is copyright infringement.",
    "release.confirm5": "I have read and accept EAM Music's Terms of Service.",
    "release.warningEditing": "Warning: This release is in review",
    "release.warningEditingDesc": "If you make changes to this release, its status will change to 'Needs Edits' and you will need to resubmit.",
    "release.adminNote": "Admin Note",
    
    // Common extras
    "common.filter": "Filter",
    "common.all": "All",
    "common.copy": "Copy",
    "common.optional": "Optional",
    "common.user": "User",
    "common.status": "Status",
    "common.default": "Default",
    "common.yes": "Yes",
    "common.no": "No",
    "common.other": "Other",
    "common.noResults": "No results found",
    
    // Profile
    "profile.title": "My Profile",
    "profile.subtitle": "View and edit your account information",
    "profile.accountInfo": "Account Information",
    "profile.addressInfo": "Address Information",
    "profile.statistics": "Statistics",
    "profile.financial": "Financial Information",
    "profile.firstName": "First Name",
    "profile.lastName": "Last Name",
    "profile.email": "Email",
    "profile.status": "Account Status",
    "profile.address": "Address",
    "profile.city": "City",
    "profile.country": "Country",
    "profile.postalCode": "Postal Code",
    
    // Statuses
    "status.draft": "Draft",
    "status.submitted": "Submitted",
    "status.inReview": "In Review",
    "status.needsEdits": "Needs Edits",
    "status.approved": "Approved",
    "status.rejected": "Rejected",
    "status.live": "Live",
    "status.scheduled": "Scheduled",
    "status.takenDown": "Taken Down",
    
    // Release Detail Page
    "releaseDetail.backToReleases": "Back to Releases",
    "releaseDetail.releaseTime": "Release Date",
    "releaseDetail.genre": "Genre",
    "releaseDetail.releaseType": "Release Type",
    "releaseDetail.explicitContent": "Explicit Content",
    "releaseDetail.releaseInfo": "Release Information",
    "releaseDetail.version": "Version",
    "releaseDetail.subGenre": "Sub-genre",
    "releaseDetail.titleLanguage": "Title Language",
    "releaseDetail.recordLabel": "Record Label",
    "releaseDetail.publisher": "Publisher",
    "releaseDetail.timeMode": "Time Mode",
    "releaseDetail.localTime": "Local Time",
    "releaseDetail.global": "Global",
    "releaseDetail.selectedPlatforms": "Selected Platforms",
    "releaseDetail.trackInfo": "Track Information",
    "releaseDetail.noTracks": "No tracks added yet",
    "releaseDetail.statusHistory": "Status History",
    "releaseDetail.untitled": "Untitled",
    "releaseDetail.englishTitle": "English Title",
    "releaseDetail.lyricsLanguage": "Lyrics Language",
    "releaseDetail.primaryArtists": "Primary Artists",
    "releaseDetail.featuredArtists": "Featured Artists",
    "releaseDetail.songwriters": "Songwriters",
    "releaseDetail.writers": "Writers",
    "releaseDetail.composers": "Composers",
    "releaseDetail.producers": "Producers",
    "releaseDetail.trackAudio": "Track Audio",
    "releaseDetail.browserNotSupported": "Your browser does not support audio playback.",
    "releaseDetail.lyrics": "Lyrics",
    
    // Admin Release
    "adminRelease.downloadPackage": "Download Package",
    "adminRelease.editNotes": "Edit Notes",
    "adminRelease.newStatus": "New Status",
    "adminRelease.reasonRequired": "Reason (Required)",
    "adminRelease.noteOptional": "Note (Optional)",
    "adminRelease.reasonPlaceholder": "Reason/note...",
    
    // Admin Review Queue
    "adminReview.subtitle": "Review and approve releases",
    "adminReview.statusFilter": "Status Filter",
    "adminReview.allStatuses": "All Statuses",
    "adminReview.noReleases": "No releases to review",
    "adminReview.noReleasesDesc": "No pending releases for the selected filter.",
    "adminReview.noDateSet": "No date set",
    
    // Admin Artists
    "adminArtists.searchPlaceholder": "Search by name or email...",
    "adminArtists.pendingApproval": "Pending Approval",
    "adminArtists.banned": "Banned",
    "adminArtists.plan": "Plan",
    "adminArtists.balance": "Balance",
    "adminArtists.withdrawable": "Withdrawable",
    
    // Release Form - Genre & Language
    "releaseForm.primaryGenre": "Primary Genre",
    "releaseForm.subGenre": "Sub-Genre",
    "releaseForm.subGenreOptional": "optional",
    "releaseForm.selectPrimaryGenre": "Select primary genre",
    "releaseForm.selectSubGenre": "Select sub-genre",
    "releaseForm.selectPrimaryFirst": "Select primary genre first",
    "releaseForm.searchGenre": "Search genre...",
    "releaseForm.searchSubGenre": "Search sub-genre...",
    "releaseForm.noGenreFound": "No genre found",
    "releaseForm.noSubGenreFound": "No sub-genre found",
    "releaseForm.trackLanguage": "Track Language",
    "releaseForm.titleLanguage": "Title Language",
    "releaseForm.selectTrackLanguage": "Select track language",
    "releaseForm.selectTitleLanguage": "Select title language",
    "releaseForm.searchLanguage": "Search language...",
    "releaseForm.noLanguageFound": "No language found",
    "releaseForm.instrumentalNote": "Marked as instrumental track",
    "releaseForm.multipleLanguagesNote": "Track contains multiple languages",
    "releaseForm.selectType": "Select release type",
    "releaseForm.track": "Track",
    "releaseForm.tracks": "Tracks",
    
    // Release Form - Explicit
    "releaseForm.explicitLyrics": "Explicit Lyrics / Parental Advisory",
    "releaseForm.selectExplicit": "Select content type",
    "releaseForm.explicitRequired": "Content type selection is required",
    "releaseForm.explicitWarning": "Warning: For Clean/Edited version, an explicit version of the same track should also exist",
    "releaseForm.explicitMarked": "This track will be marked as containing explicit content",
    "releaseForm.radioEditVersion": "Radio Edit version",
    "releaseForm.explicit": "Explicit",
    "releaseForm.explicitDesc": "Contains explicit language or content",
    "releaseForm.cleanEdited": "Clean / Edited (Radio Edit)",
    "releaseForm.cleanEditedDesc": "Edited version of an explicit track",
    "releaseForm.notExplicit": "Not Explicit",
    "releaseForm.notExplicitDesc": "Does not contain explicit content",
    "releaseForm.unknown": "Unknown",
    "releaseForm.unknownDesc": "Explicit status is unknown",
    
    // Release Form - Other
    "releaseForm.isInstrumental": "Is Instrumental?",
    "releaseForm.instrumentalDesc": "This track is instrumental (no vocals)",
    "releaseForm.featuredArtists": "Featured Artists",
    "releaseForm.addFeaturedArtist": "Add featured artist",
    "releaseForm.primaryArtist": "Primary Artist",
    "releaseForm.trackTitle": "Track Title",
    "releaseForm.enterTrackTitle": "Enter track title",
    "releaseForm.trackTitleRequired": "Track title is required",
    "releaseForm.primaryArtistRequired": "Primary artist is required",
    "releaseForm.primaryGenreRequired": "Primary genre selection is required",
    "releaseForm.trackLanguageRequired": "Track language selection is required",
    
    // Single Release Wizard
    "wizard.audioFile": "Audio File",
    "wizard.readyForDistribution": "Ready for distribution",
    "wizard.uploading": "Uploading...",
    "wizard.pleaseWait": "Please wait",
    "wizard.uploadAudioFile": "Upload Audio File",
    "wizard.audioFormatInfo": "WAV or FLAC • 44.1-96kHz • 16/24 bit",
    "wizard.trackDetails": "Track Details",
    "wizard.trackTitle": "Track Title",
    "wizard.enterTrackTitle": "Enter track title",
    "wizard.primaryArtist": "Primary Artist",
    "wizard.artistName": "Artist name",
    "wizard.coverArt": "Cover Art",
    "wizard.coverRequirements": "Cover Requirements",
    "wizard.squareFormat": "Square format (1:1 ratio)",
    "wizard.minResolution": "Minimum 3000x3000 pixels",
    "wizard.formatJpgPng": "JPG or PNG format",
    "wizard.noUrlsAllowed": "No URLs or social media links",
    "wizard.noBluryImages": "No blurry or pixelated images",
    "wizard.uploadCover": "Upload Cover Image",
    "wizard.coverUploaded": "Cover uploaded",
    "wizard.distributionType": "Distribution Type",
    "wizard.wasThisReleased": "Was this track previously released?",
    "wizard.newRelease": "New Release",
    "wizard.newReleaseDesc": "First time release. UPC and ISRC codes will be assigned by admin.",
    "wizard.transferRelease": "Transfer from Another Distributor / Previously Released",
    "wizard.transferReleaseDesc": "You need to enter your existing UPC and ISRC codes.",
    "wizard.upcCode": "UPC Code",
    "wizard.isrcCode": "ISRC Code",
    "wizard.originalReleaseDate": "Original Release Date",
    
    // Explicit options
    "explicit.explicit": "Explicit",
    "explicit.explicitDesc": "Contains explicit or adult content such as strong language, violence, or sexual themes.",
    "explicit.clean": "Clean / Edited",
    "explicit.cleanDesc": "A radio-safe version with explicit content removed or edited. Requires an explicit version to exist.",
    "explicit.notExplicit": "Not Explicit",
    "explicit.notExplicitDesc": "Does not contain any explicit content. Family-friendly.",
    "explicit.unknown": "Unknown",
    "explicit.unknownDesc": "Content rating is undetermined or not applicable.",
    
    "wizard.credits": "Credits",
    "wizard.songwriters": "Songwriters",
    "wizard.add": "Add",
    "wizard.songwriterName": "Full name (e.g., John Smith)",
    "wizard.songwriterPlaceholder": "e.g., John Smith",
    "wizard.lyricists": "Lyricists",
    "wizard.lyricistName": "Lyricist name",
    "wizard.contributors": "Contributors",
    "wizard.contributorPlaceholder": "e.g., Jane Doe",
    "wizard.producerPlaceholder": "e.g., Alex Johnson",
    "wizard.name": "Name",
    "wizard.selectRole": "Select role *",
    "wizard.productionTeam": "Production Team",
    "wizard.recordLabel": "Record Label",
    "wizard.recordLabelOptional": "Record label name (optional)",
    "wizard.versionPlaceholder": "e.g., Deluxe Edition, Acoustic, Remix",
    "wizard.isrcPlaceholder": "e.g., USRC17607839",
    "wizard.minResolutionRecommended": "Min 1400x1400 px (3000x3000 recommended)",
    "wizard.upcPlaceholder": "Enter 12-digit UPC code",
    "wizard.licensedContent": "Licensed Content",
    "wizard.licensedContentQuestion": "Does this track contain samples, beats, stock sounds or remixes?",
    "wizard.noOriginal": "No, completely original",
    "wizard.yesLicensed": "Yes, contains licensed content",
    "wizard.licenseRequired": "License Document Required",
    "wizard.licenseRequiredDesc": "To verify your use of licensed content, please upload your license document (PDF).",
    "wizard.uploadLicense": "Upload License Document",
    "wizard.pdfOnly": "Only PDF format accepted",
    "wizard.trackSettings": "Track Settings",
    
    // Credit roles
    "creditRoles.composer": "Composer",
    "creditRoles.lyricist": "Lyricist",
    "creditRoles.composerLyricist": "Composer & Lyricist",
    "creditRoles.arranger": "Arranger",
    "creditRoles.mixer": "Mixer",
    "creditRoles.mastering": "Mastering",
    "creditRoles.recording": "Recording",
    "creditRoles.instrumentalist": "Instrumentalist",
    "creditRoles.vocalist": "Vocalist",
    "creditRoles.other": "Other",
    "creditRoles.producer": "Producer",
    "creditRoles.executiveProducer": "Executive Producer",
    "creditRoles.coProducer": "Co-Producer",
    "creditRoles.engineer": "Engineer",
    "creditRoles.assistant": "Assistant",
    
    // Release form
    "releaseForm.instrumental": "Instrumental (No Lyrics)",
    "releaseForm.multipleLanguages": "Multiple Languages",
    
    // Track specific
    "wizard.track.lyricsLanguage": "Track Language (Language of Lyrics)",
    "wizard.track.lyricsLanguageDesc": "Language of the lyrics or vocals",
    "wizard.track.explicitLyrics": "Explicit Lyrics / Parental Advisory",
    "wizard.track.selectContentType": "Select content type",
    "wizard.track.addFeaturedArtist": "Add featured artist",
    "wizard.track.useExistingIsrc": "Use existing ISRC code",
    
    "wizard.licenseDocument": "License document",
    "wizard.uploaded": "Uploaded",
    "wizard.licenseUploaded": "License document uploaded",
    "wizard.licenseUploadFailed": "License document upload failed",
    
    // Wizard Section Tabs
    "wizard.sections.trackInfo": "Track Information",
    "wizard.sections.releaseSettings": "Release Settings",
    "wizard.sections.moreOptions": "More Options",
    "wizard.sections.review": "Review",
    
    // Wizard Page Header
    "wizard.newSingleRelease": "New Single Release",
    "wizard.newSingleReleaseDesc": "Complete all sections to submit your release",
    "wizard.selectReleaseType": "Select Release Type",
    "wizard.singleTrack": "Single Track",
    "wizard.singleTrackDesc": "Publish a single track. Fast and easy process.",
    "wizard.epAlbum": "EP / Album",
    "wizard.epAlbumDesc": "Create a release with 2+ tracks.",
    "wizard.loadFromDrafts": "Load from Drafts",
    "wizard.goBack": "Go Back",
    
    // Wizard Toast Messages
    "wizard.audioUploaded": "Audio file uploaded",
    "wizard.audioUploadFailed": "Audio file upload failed",
    "wizard.coverMustBeSquare": "Cover image must be square (1:1)",
    "wizard.coverMinResolution": "Cover image must be at least 3000x3000 pixels",
    "wizard.coverReadFailed": "Image could not be read",
    "wizard.coverUploaded": "Cover image uploaded",
    "wizard.coverUploadFailed": "Cover image upload failed",
    "wizard.releaseLoadFailed": "Release could not be loaded",
    "wizard.draftsLoadFailed": "Drafts could not be loaded",
    "wizard.fixSectionErrors": "Please fix the errors in this section",
    "wizard.draftSaved": "Draft saved",
    "wizard.draftSaveFailed": "Draft could not be saved",
    "wizard.releaseSubmitted": "Release submitted successfully!",
    "wizard.releaseSubmitFailed": "Release could not be submitted",
    "wizard.drafts": "Drafts",
    "wizard.noDrafts": "No draft releases yet",
    "wizard.untitledRelease": "Untitled Release",
    "wizard.deleteDraft": "Delete Draft",
    
    // Validation messages
    "validation.minContributors": "You must add at least one contributor",
    "validation.minProductionTeam": "You must add at least one production team member",

    // Spotify
    "spotify.title": "Spotify for Artists",
    "spotify.comingSoon": "Coming Soon",
    "spotify.description": "Access your Spotify Artist account directly from EAM panel. We're working on this feature.",
    
    // Admin
    "admin.dashboard": "Dashboard",
    "admin.reviewQueue": "Review Queue",
    "admin.artists": "Artists",
    "admin.announcements": "Announcements",
    "admin.pendingUsers": "Pending Users",
    "admin.pendingReleases": "Pending Releases",
    "admin.payoutRequests": "Payout Requests",
    "admin.deleteUser": "Delete User",
    "admin.deleteUserConfirm": "⚠️ This user, all their releases and support tickets will be permanently deleted. This action cannot be undone!",
    "admin.yesDelete": "Yes, Delete",
    "admin.close": "Close",
    "admin.deleteTicket": "Delete Support Ticket",
    "admin.deleteTicketConfirm": "This support ticket and all messages will be permanently deleted. This action cannot be undone.",
    "admin.deleteRelease": "Delete Release",
    "admin.deleteReleaseConfirm": "⚠️ This release and all audio files will be permanently deleted. This action cannot be undone!",
    "admin.deleteFailed": "Delete failed",
    
    // Notifications
    "notifications.title": "Notifications",
    "notifications.markAllRead": "Mark all read",
    "notifications.none": "No notifications",
    "notifications.empty": "No notifications yet",
    
    // Common
    "common.yes": "Yes",
    "common.no": "No",
    "common.cancel": "Cancel",
    "common.add": "Add",
    "common.update": "Update",
    "common.delete": "Delete",
    "common.save": "Save",
    "common.current": "Current",
    "common.optional": "Optional",
    "common.untitled": "Untitled",
    "common.unknownArtist": "Unknown Artist",
    "common.operationFailed": "Operation failed",
    
    // Wizard - Lyrics
    "wizard.lyrics.label": "Lyrics (Optional)",
    "wizard.lyrics.placeholder": "Enter lyrics here...",
    "wizard.lyrics.description": "Lyrics may be displayed on DSPs (Apple Music, Spotify, etc.)",
    
    // Wizard - Publishing
    "wizard.publishing.percentPlaceholder": "Enter percentage (1-99)",
    "wizard.publishing.hasPublisher": "Do you have a publisher?",
    "wizard.publishing.publisherName": "Publisher Name",
    "wizard.publishing.publisherPlaceholder": "Enter publisher name",
    "wizard.publishing.registeredPro": "Are you registered with a PRO/CMO?",
    
    // Wizard - Uploaded files
    "wizard.uploadedCover": "Uploaded cover",
    "wizard.uploadedFile": "Uploaded file",
    
    // Payout Methods
    "payoutMethods.otpSent": "Verification code sent to your email",
    "payoutMethods.otpRequired": "Enter the 6-digit verification code",
    "payoutMethods.methodUpdated": "Your payment method has been updated",
    "payoutMethods.verificationFailed": "Verification failed",
    "payoutMethods.editMethod": "Edit Payment Method",
    "payoutMethods.addMethod": "Add Payment Method",
    "payoutMethods.editDesc": "Update your existing payment method",
    "payoutMethods.addDesc": "Add a payment method to withdraw your earnings",
    "payoutMethods.bank": "Bank",
    "payoutMethods.accountHolder": "Account Holder Name",
    "payoutMethods.fullName": "Full Name",
    "payoutMethods.bankName": "Bank Name",
    "payoutMethods.country": "Country",
    "payoutMethods.countryPlaceholder": "United States",
    "payoutMethods.paypalEmail": "PayPal Email Address",
    "payoutMethods.title": "Payment Methods",
    "payoutMethods.subtitle": "Add your payment method to withdraw your earnings",
    "payoutMethods.addNew": "Add New",
    "payoutMethods.securityNotice": "Security Notice",
    "payoutMethods.securityDesc": "All changes to your payment methods require email verification. This is to protect your account from unauthorized access.",
    "payoutMethods.noMethods": "No Payment Method Found",
    "payoutMethods.noMethodsDesc": "You need to add a payment method to be able to withdraw your earnings.",
    "payoutMethods.bankTransfer": "Bank Transfer",
    "payoutMethods.default": "Default",
    "payoutMethods.verified": "Verified",
    "payoutMethods.emailVerification": "Email Verification",
    "payoutMethods.enterOtp": "Enter the 6-digit code sent to your email",
    "payoutMethods.verificationCode": "Verification Code",
    "payoutMethods.codeExpires": "Code will expire in {time}",
    "payoutMethods.codeExpired": "Code has expired. Please request a new one.",
    "payoutMethods.resendIn": "Resend in",
    "payoutMethods.resendCode": "Resend Code",
    "payoutMethods.verify": "Verify",
    "payoutMethods.deleteMethod": "Delete Payment Method",
    "payoutMethods.deleteConfirm": "Are you sure you want to delete this payment method? This action cannot be undone.",
    
    // Login
    "login.heroTitle": "Distribute Your",
    "login.heroHighlight": "Music to the World",
    "login.heroSubtitle": "Publish your music on Spotify, Apple Music, YouTube Music and more.",
    "auth.forgotPassword": "Forgot Password",
    "auth.resetPassword": "Reset Password",
    "auth.resetPasswordDesc": "Enter your email and we'll send you a reset link.",
    "auth.sendResetLink": "Send Reset Link",
    "auth.backToLogin": "Back to Login",
    "auth.resetLinkSent": "Password reset link sent to your email.",
    "auth.turnstileRequired": "Please complete the security verification",
    
    // Artist Autocomplete
    "artist.saved": "Saved",
    "artist.noResults": "No saved artist found",
    "artist.saveArtist": "Save \"{name}\" as artist",
    "artist.addArtist": "Add \"{name}\"",
    "artist.addPlaceholder": "Add artist",
    "artist.addPrimaryArtist": "Add primary artist",
    "artist.addFeaturedArtist": "Add featured artist",
    "artist.artistName": "Artist name",
    "artist.enterOrSearch": "Enter or search artist name",
    "artist.noMatching": "No matching artists found",
    "artist.addAsArtist": "Add \"{name}\" as an artist",
    "artist.enterMinChars": "Enter at least 2 characters to search",
    "artist.searchSpotify": "Search",
    "artist.manualLink": "Paste Link",
    "artist.spotifyProfileLink": "Spotify Artist Link",
    "artist.spotifyLinkHelp": "Paste Spotify artist profile URL or artist ID",
    "artist.linkSpotify": "Link Spotify Profile",
    "artist.addWithoutSpotify": "Add without Spotify link",
    "artist.tryManualLink": "Try 'Paste Link' tab to enter Spotify URL",
    "artist.invalidSpotifyLink": "Invalid Spotify link or ID",
    "artist.nameRequired": "Artist name is required",
    "artist.spotifyLinked": "Spotify profile linked successfully",
    "artist.spotifyIdSaved": "Spotify ID saved",
    
    // Releases Page
    "releases.allReleases": "All Releases",
    "releases.drafts": "Drafts",
    "releases.tableTitle": "Title",
    "releases.tableArtist": "Artist",
    "releases.tableTracks": "Tracks",
    "releases.tableLastUpdate": "Last Update",
    "releases.tableProgress": "Progress",
    "releases.tableActions": "Actions",
    "releases.releaseDate": "Release Date",
    "releases.deleteDraftTitle": "Delete Draft",
    "releases.deleteReleaseTitle": "Delete Release",
    "releases.deleteFailed": "Delete failed",
    "releases.untitled": "Untitled",
    "releases.needsEdits": "Needs Edits",
    "releases.yesRemoveBtn": "Yes, Remove",
    "releases.deleteBtn": "Delete",
    
    // Credit Roles (Canonical IDs)
    "role.COMPOSER": "Composer",
    "role.LYRICIST": "Lyricist",
    "role.COMPOSER_LYRICIST": "Composer & Lyricist",
    "role.PRODUCER": "Producer",
    "role.EXECUTIVE_PRODUCER": "Executive Producer",
    "role.CO_PRODUCER": "Co-Producer",
    "role.ASSOCIATE_PRODUCER": "Associate Producer",
    "role.MIXING_ENGINEER": "Mixing Engineer",
    "role.MASTERING_ENGINEER": "Mastering Engineer",
    "role.RECORDING_ENGINEER": "Recording Engineer",
    "role.ASSISTANT_ENGINEER": "Assistant Engineer",
    "role.ARRANGER": "Arranger",
    "role.REMIXER": "Remixer",
    "role.ORCHESTRA": "Orchestra",
    "role.CHOIR": "Choir",
    
    // Tax Status
    "tax.required": "Tax Information Required",
    "tax.requiredDesc": "Tax information must be completed before requesting a payout",
    "tax.statusNone": "Not specified",
    "tax.statusPersonal": "Individual",
    "tax.statusCompany": "Company",
    "tax.cannotPayout": "Cannot request payout",
    
    // Validation Messages
    "validation.audioRequired": "Audio file is required",
    "validation.audioFormatWav": "Audio file must be in WAV or FLAC format",
    "validation.sampleRate": "Sample rate must be between 44.1kHz - 96kHz",
    "validation.bitDepth": "Bit depth must be 16 or 24 bit",
    "validation.titleRequired": "Track title is required",
    "validation.titleLanguageRequired": "Title language is required",
    "validation.primaryArtistRequired": "At least one primary artist is required",
    "validation.primaryGenreRequired": "Primary genre selection is required",
    "validation.explicitRequired": "Content type selection is required",
    "validation.explicitWarning": "Warning: Clean/Edited version should have an explicit version",
    "validation.coverRequired": "Cover image is required",
    "validation.distributionTypeRequired": "Distribution type selection is required",
    "validation.upcRequired": "UPC code is required for transfer",
    "validation.isrcRequired": "ISRC code is required for transfer",
    "validation.originalDateRequired": "Original release date is required",
    "validation.songwriterRequired": "At least one songwriter is required",
    "validation.songwriterNameFormat": "Songwriters must be in Full Name format (e.g., John Smith)",
    "validation.songwriterRoleRequired": "Role selection is required for each songwriter",
    "validation.licensedContentRequired": "Licensed content status is required",
    "validation.licenseFileRequired": "License document (PDF) is required",
    "validation.contributorRequired": "At least one contributor is required",
    "validation.contributorNameFormat": "Contributors must be in Full Name format (e.g., John Smith)",
    "validation.productionTeamRequired": "At least one production team member is required",
    "validation.productionTeamNameFormat": "Production team members must be in Full Name format (e.g., John Smith)",
    "validation.platformRequired": "At least one platform selection is required",
    "validation.timeSyncRequired": "Time synchronization selection is required",
    "validation.releaseDateRequired": "Release date is required",
    "validation.releaseDateMinDays": "Release date must be at least 7 days in the future",
    "validation.trackCountRequired": "At least 2 tracks are required for EP/Album",
    "validation.trackLanguageRequired": "Track language selection is required",
    "validation.trackHasErrors": "This track has errors that need to be fixed",
    "validation.fixSectionErrors": "Please fix the errors in this section",
    "validation.weeklyLimitReached": "You have reached your weekly withdrawal limit (2/2). Please try again next week.",
    "validation.firstArtistMustMatch": "First primary artist must be",
    "validation.artistMustMatchAlbum": "Track artists must match at least one album artist",
    "validation.isrcRequiredTransfer": "ISRC code is required for transferred releases",
    "validation.publishingRequired": "Publishing rights percentage is required",
    "validation.publisherStatusRequired": "Publisher status is required",
    "validation.publisherNameRequired": "Publisher name is required",
    "validation.proStatusRequired": "PRO/CMO registration status is required",
    "validation.proSelectionRequired": "PRO selection is required",
    "validation.ipiRequired": "IPI number is required",
    "validation.validPercentage": "Enter a valid percentage (1-99)",
    "validation.ownershipRequired": "Ownership confirmation is required",
    "validation.termsRequired": "You must accept the terms",
    "releases.track": "Track",
    
    // Toast Messages
    "toast.saveSuccess": "Saved successfully",
    "toast.saveFailed": "Failed to save",
    "toast.deleteSuccess": "Deleted successfully",
    "toast.deleteFailed": "Failed to delete",
    "toast.uploadSuccess": "Uploaded successfully",
    "toast.uploadFailed": "Failed to upload",
    "toast.submitSuccess": "Submitted successfully",
    "toast.submitFailed": "Failed to submit",
    "toast.loginSuccess": "Login successful",
    "toast.loginFailed": "Login failed",
    "toast.logoutSuccess": "Logout successful",
    "toast.copySuccess": "Copied to clipboard",
    "toast.errorOccurred": "An error occurred",
    "toast.pleaseFixErrors": "Please fix the errors in this section",
    "toast.releaseSubmitted": "Release submitted successfully!",
    "toast.draftSaved": "Draft saved successfully",
    "toast.coverUploaded": "Cover image uploaded",
    "toast.audioUploaded": "Audio file uploaded",
    "toast.invalidCredentials": "Invalid email or password",
    "toast.sessionExpired": "Session expired. Please login again.",

    // === Auto-generated i18n keys ===
    "aiAdvisor.aiName": "AI",
    "aiAdvisor.title": "AI Music Advisor",
    "aiAdvisor.subtitle": "Get AI-powered strategies and analytics for your career.",
    "aiAdvisor.thinking": "AI is thinking...",
    "aiAdvisor.stats.totalReleases": "Total Releases",
    "aiAdvisor.stats.totalTracks": "Total Tracks",
    "aiAdvisor.stats.chatHistory": "Chat History",
    "aiAdvisor.stats.messages": "Messages",
    "aiAdvisor.support.email": "Your Email Address",
    "aiAdvisor.support.problem": "Your Problem (Briefly)",
    "aiAdvisor.clear": "Clear",
    "aiAdvisor.clearChat": "Clear Chat",
    "aiAdvisor.connectAgent": "Connect to a Customer Representative",
    "aiAdvisor.contextDesc": "The AI takes your current account data into consideration to provide personalized advice.",
    "aiAdvisor.contextTitle": "Advisor Context",
    "aiAdvisor.errors.cannotRespond": "Sorry, I cannot respond right now. Please try again later.",
    "aiAdvisor.errors.fillFields": "Please fill out all fields.",
    "aiAdvisor.errors.generic": "An error occurred, please try again.",
    "aiAdvisor.errors.noChatToExport": "No chat found to export.",
    "aiAdvisor.errors.ticketFailed": "Error creating support request.",
    "aiAdvisor.export": "Export",
    "aiAdvisor.inputPlaceholder": "Ask the AI a question about your music career...",
    "aiAdvisor.prompts.audienceAnalysis": "Audience analysis",
    "aiAdvisor.prompts.brandingAdvice": "Branding advice",
    "aiAdvisor.prompts.growthTips": "Give growth tips",
    "aiAdvisor.prompts.livePerformance": "Live performance strategy",
    "aiAdvisor.prompts.playlistPitching": "Playlist pitching strategy",
    "aiAdvisor.prompts.releaseStrategy": "What should my release strategy be?",
    "aiAdvisor.prompts.revenueOptimization": "Revenue optimization",
    "aiAdvisor.prompts.socialMediaPlan": "Create a social media plan",
    "aiAdvisor.stats.accountStatus": "Account Status",
    "aiAdvisor.stats.active": "Active",
    "aiAdvisor.success.chatCleared": "Chat cleared.",
    "aiAdvisor.success.chatExported": "Chat exported.",
    "aiAdvisor.success.ticketCreated": "Support request created. We will get back to you soon.",
    "aiAdvisor.support.cancel": "Cancel",
    "aiAdvisor.support.desc": "Our customer representatives will contact you as soon as possible.",
    "aiAdvisor.support.send": "Send",
    "aiAdvisor.support.title": "Create Support Request",
    "aiAdvisor.supportSubject": "AI Advisor - Support Request",
    "aiAdvisor.tipDesc": "Provide specific details to the AI for more accurate results.",
    "aiAdvisor.tipTitle": "Tip",
    "aiAdvisor.welcomeDesc": "You can ask questions about the music industry, release strategies, marketing, and increasing revenue.",
    "aiAdvisor.welcomeTitle": "How can I help you?",
    "aiAdvisor.you": "You",
    "aiMatcher.aiStrategyTips": "AI Strategy Suggestions",
    "aiMatcher.analysisComplete": "AI analysis completed",
    "aiMatcher.analysisResults": "Analysis Results",
    "aiMatcher.analyzingDesc": "Your track's features are being compared with thousands of playlists.",
    "aiMatcher.analyzingDna": "Analyzing Musical DNA...",
    "aiMatcher.description": "Discover your music's potential with our advanced algorithms.",
    "aiMatcher.errorAnalysis": "An error occurred during analysis.",
    "aiMatcher.errorLoading": "An error occurred while loading data.",
    "aiMatcher.errorSelectRelease": "Please select a release",
    "aiMatcher.genreAnalysis": "Genre Analysis",
    "aiMatcher.highPotential": "High Potential",
    "aiMatcher.newAnalysis": "New Analysis",
    "aiMatcher.noPastAnalyses": "No past analyses yet.",
    "aiMatcher.noReleases": "No approved or released music found to analyze.",
    "aiMatcher.overallScore": "Overall Compatibility Score",
    "aiMatcher.pastAnalyses": "Past Analyses",
    "aiMatcher.perfectMatch": "Perfect Match",
    "aiMatcher.selectRelease": "Select Release to Analyze",
    "aiMatcher.single": "Single",
    "aiMatcher.startAnalysis": "Start Analysis",
    "aiMatcher.suggestedTiming": "Suggested Release Time",
    "aiMatcher.targetPlaylists": "Target Playlists",
    "aiMatcher.unknown": "Unknown",
    "aiStudio.analyze": "Analyze",
    "aiStudio.audioRepairDesc": "Repair clipping and distortions",
    "aiStudio.audioRepairName": "AI Audio Repair",
    "aiStudio.clarity": "Clarity",
    "aiStudio.clean": "Clean",
    "aiStudio.copyrightDesc": "Scan for potential copyright issues",
    "aiStudio.copyrightName": "AI Copyright Scanner",
    "aiStudio.coverGenDesc": "Generate album cover from text",
    "aiStudio.coverGenName": "AI Cover Generator",
    "aiStudio.desc": "AI-powered professional music tools hub.",
    "aiStudio.description": "Description",
    "aiStudio.distReadyDesc": "Check distribution standards",
    "aiStudio.distReadyName": "AI Distribution Readiness",
    "aiStudio.download": "Download",
    "aiStudio.downloading": "Downloading file...",
    "aiStudio.dragDropClick": "Drag and drop or click to select",
    "aiStudio.dynamic": "Dynamic",
    "aiStudio.failed": "Failed",
    "aiStudio.frequency": "Frequency",
    "aiStudio.genreDetDesc": "Genre detection from audio file",
    "aiStudio.genreDetName": "AI Genre Detection",
    "aiStudio.history": "History",
    "aiStudio.intensity": "Intensity",
    "aiStudio.issue": "Issue",
    "aiStudio.loudnessOptDesc": "Optimize to target LUFS value",
    "aiStudio.loudnessOptName": "AI Loudness Optimization",
    "aiStudio.lyricVideoDesc": "Timed lyric video",
    "aiStudio.lyricVideoName": "AI Lyric Video",
    "aiStudio.lyrics": "Lyrics",
    "aiStudio.lyricsPlaceholder": "Paste lyrics here...",
    "aiStudio.metadataGenDesc": "Generate title, description, and tags",
    "aiStudio.metadataGenName": "AI Metadata Generator",
    "aiStudio.modules": "Modules",
    "aiStudio.moodDetDesc": "Energy and emotion analysis",
    "aiStudio.moodDetName": "AI Mood Detection",
    "aiStudio.musicVideoDesc": "Generate audio-reactive video",
    "aiStudio.musicVideoName": "AI Music Video",
    "aiStudio.needAudioFile": "Please upload an audio file first",
    "aiStudio.needPrompt": "Please enter a prompt",
    "aiStudio.noFileToDownload": "No file to download",
    "aiStudio.noFileToPlay": "No file to play",
    "aiStudio.noHistory": "You haven't done any processing yet.",
    "aiStudio.noiseRemovalDesc": "Clean up background noise",
    "aiStudio.noiseRemovalName": "AI Noise Removal",
    "aiStudio.passed": "Passed",
    "aiStudio.processError": "An error occurred during the process",
    "aiStudio.processHistory": "Process History",
    "aiStudio.processSuccess": "Process completed successfully!",
    "aiStudio.processing": "Processing...",
    "aiStudio.promptPlaceholder": "E.g.: A neon-lit synthwave car...",
    "aiStudio.qualityScoreDesc": "Score audio quality from 0-100",
    "aiStudio.qualityScoreName": "AI Audio Quality Score",
    "aiStudio.resultsReady": "Results Ready",
    "aiStudio.startProcess": "Start Process",
    "aiStudio.stemSepDesc": "Separate vocals, drums, and bass",
    "aiStudio.stemSepName": "AI Stem Separation",
    "aiStudio.suggestedTitle": "Suggested Title",
    "aiStudio.tags": "Tags",
    "aiStudio.title": "AI Studio",
    "aiStudio.uploadAudioFile": "Upload Audio File",
    "aiStudio.view": "View",
    "aiStudio.visualPrompt": "Visual Prompt",
    "aiStudio.vocalEnhDesc": "Enhance vocal clarity and brightness",
    "aiStudio.vocalEnhName": "AI Vocal Enhancement",
    "aiVideo.addedToList": "Great! You are added to the list",
    "aiVideo.beFirst": "Be among the first to try",
    "aiVideo.desc": "AI-powered music videos coming soon!",
    "aiVideo.emailPlaceholder": "Your email address...",
    "aiVideo.enterEmail": "Please enter an email address",
    "aiVideo.hdDesc": "1080p and 4K resolution for professional releases",
    "aiVideo.hdTitle": "HD Quality",
    "aiVideo.joinWaitlist": "Join the waitlist for early access.",
    "aiVideo.notifyMe": "Notify Me",
    "aiVideo.premiumFeature": "Premium Feature",
    "aiVideo.styleDesc": "8+ visual styles including cinematic, anime, abstract",
    "aiVideo.styleTitle": "Style Selection",
    "aiVideo.syncDesc": "Fully automatic sync to the rhythm of the music",
    "aiVideo.syncTitle": "Auto Synchronization",
    "aiVideo.textToVideoDesc": "Create your dream scene by typing a prompt",
    "aiVideo.textToVideoTitle": "Text to Video",
    "aiVideo.title": "AI Video Generator",
    "aiVideo.waitlistSuccess": "You have been added to the waitlist!",
    "aiVideo.willNotify": "We will notify you when the feature is released.",
    "analytics.audienceDemographics": "Audience Demographics",
    "analytics.azerbaijan": "Azerbaijan",
    "analytics.estimatedRevenue": "Estimated Revenue",
    "analytics.female": "Female",
    "analytics.geographicDistribution": "Geographic Distribution",
    "analytics.germany": "Germany",
    "analytics.male": "Male",
    "analytics.noData": "No Data Yet",
    "analytics.noTrackData": "No track data yet",
    "analytics.other": "Other",
    "analytics.otherCountries": "Other",
    "analytics.popularTrack": "Popular Track",
    "analytics.popularityScore": "Popularity Score",
    "analytics.refresh": "Refresh",
    "analytics.refreshData": "Refresh Data",
    "analytics.revenueForecast": "Revenue Forecast (6 Months)",
    "analytics.streamsTrend": "Streams Trend",
    "analytics.totalStreamsStat": "Total Streams",
    "analytics.turkey": "Turkey",
    "analytics.usa": "USA",
    "artistConnections.apiIntegration": "API Integration",
    "artistConnections.betaTesting": "Beta Testing",
    "artistConnections.centralManagement": "Central Management",
    "artistConnections.centralManagementDesc": "Manage all your artist profiles on platforms from a single panel.",
    "artistConnections.comingSoon": "Coming Soon",
    "artistConnections.description": "Connect, manage, and sync your artist profiles on music platforms.",
    "artistConnections.developmentProgress": "Development Progress",
    "artistConnections.instantSync": "Instant Sync",
    "artistConnections.instantSyncDesc": "Profile updates automatically reflect on all connected platforms.",
    "artistConnections.notifyMe": "Notify Me When Ready",
    "artistConnections.release": "Release",
    "artistConnections.secureConnection": "Secure Connection",
    "artistConnections.secureConnectionDesc": "Secure platform verification and data access with OAuth 2.0.",
    "artistConnections.supportedPlatforms": "Supported Platforms",
    "artistConnections.title": "Artist Connections",
    "artistConnections.uiDesign": "UI Design",
    "artistConnections.unifiedAnalytics": "Unified Analytics",
    "artistConnections.unifiedAnalyticsDesc": "View data from all platforms on a single dashboard.",
    "bioLink.addNewLink": "Add New Link",
    "bioLink.artistName": "Artist Name",
    "bioLink.avatarUpdated": "Profile picture updated!",
    "bioLink.bgUploaded": "Background uploaded",
    "bioLink.bioLabel": "Biography",
    "bioLink.change": "Change",
    "bioLink.copy": "Copy",
    "bioLink.ctr": "Click-Through Rate (CTR)",
    "bioLink.customBgImage": "Custom Background Image",
    "bioLink.defaultBio": "Music and more...",
    "bioLink.defaultLink1": "Listen to My New Single",
    "bioLink.defaultLink2": "My Official Website",
    "bioLink.description": "Manage all your digital presence with a single link",
    "bioLink.errorFileSize": "File size must be less than 5MB",
    "bioLink.errorSelectImage": "Please select an image file",
    "bioLink.latestReleases": "Latest Releases",
    "bioLink.linkCopied": "Link copied!",
    "bioLink.linkTitlePlaceholder": "Link Title",
    "bioLink.newLink": "New Link",
    "bioLink.presetThemes": "Preset Themes",
    "bioLink.profileNameLabel": "Profile Name",
    "bioLink.qrCode": "QR Code",
    "bioLink.save": "Save",
    "bioLink.saveError": "An error occurred while saving",
    "bioLink.saveSuccess": "Your bio link has been saved successfully!",
    "bioLink.saving": "Saving...",
    "bioLink.socialsDesc": "Add your social media accounts to appear on your profile.",
    "bioLink.tabLinks": "Links",
    "bioLink.tabProfile": "Profile",
    "bioLink.tabSocials": "Social Media",
    "bioLink.tabTheme": "Theme",
    "bioLink.title": "Smart Bio Link",
    "bioLink.totalClicks": "Total Clicks",
    "bioLink.totalViews": "Total Views",
    "bioLink.unknown": "Unknown",
    "bioLink.untitled": "Untitled",
    "bioLink.uploadBgImage": "Upload background image",
    "bioLink.uploadFailed": "Upload failed",
    "campaigns.approved": "Approved",
    "campaigns.approvedCount": "Approved",
    "campaigns.back": "Back",
    "campaigns.cancelled": "Cancelled",
    "campaigns.createNewCampaign": "Create New Campaign",
    "campaigns.createSuccess": "Campaign created successfully!",
    "campaigns.date": "Date",
    "campaigns.newCampaign": "New Campaign",
    "campaigns.newPitchCampaign": "New Pitch Campaign",
    "campaigns.next": "Next",
    "campaigns.noCampaigns": "No Campaigns Found",
    "campaigns.noCampaignsDesc": "There are no campaigns matching these filters.",
    "campaigns.noMessage": "No message entered",
    "campaigns.pending": "Pending",
    "campaigns.pendingCount": "Pending",
    "campaigns.pitchMessage": "Pitch Message",
    "campaigns.pitchPlaceholder": "Ex: This track reflects the summer energy...",
    "campaigns.reachPotential": "Reach Pot.",
    "campaigns.rejected": "Rejected",
    "campaigns.rejectedCount": "Rejected",
    "campaigns.selectedRelease": "Selected Release",
    "campaigns.startCampaign": "Start Campaign",
    "campaigns.step1Desc": "Select the release you want to create a campaign for.",
    "campaigns.step1Title": "1. Release Selection",
    "campaigns.step2Desc": "Select the curators/playlists you want to pitch your release to.",
    "campaigns.step2Title": "2. Target Playlists",
    "campaigns.step3Desc": "Briefly tell curators why they should add your track to their playlist.",
    "campaigns.step3Title": "3. Pitch Message",
    "campaigns.subtitle": "Manage and track your playlist applications",
    "campaigns.summaryTitle": "Summary & Confirmation",
    "campaigns.target": "Target",
    "campaigns.targetPlaylists": "Target Playlists",
    "campaigns.title": "Campaigns",
    "campaigns.totalApplications": "Total Applications",
    "canvasStudio.aiEffectsDesc": "AI-powered visual effects and filters",
    "canvasStudio.aiEffectsTitle": "AI Effects",
    "canvasStudio.aiVideoGenDesc": "Automatically generate music videos with AI",
    "canvasStudio.aiVideoGenTitle": "AI Video Generator",
    "canvasStudio.audioVisDesc": "Real-time visualization synced to your music",
    "canvasStudio.audioVisTitle": "Audio Visualizer",
    "canvasStudio.autoSyncDesc": "Auto-synced visual effects to the beat",
    "canvasStudio.autoSyncTitle": "Auto Sync",
    "canvasStudio.canvasTempDesc": "Professional animation templates for Spotify Canvas",
    "canvasStudio.canvasTempTitle": "Canvas Templates",
    "canvasStudio.desc": "Canvas Studio is currently under maintenance. It will be back soon with powerful tools!",
    "canvasStudio.maintenance": "Under Maintenance — New Features Coming Soon",
    "canvasStudio.motionGraphDesc": "Professional motion graphics and animations",
    "canvasStudio.motionGraphTitle": "Motion Graphics",
    "canvasStudio.notify": "You will be notified when this feature is updated",
    "canvasStudio.title": "Canvas Studio",
    "canvasStudio.upcoming": "Upcoming Features",
    "contributors.addNew": "Add New",
    "contributors.release": "Release",
    "contributors.pay": "Pay",
    "contributors.invite": "Send Invite",
    "contributors.remove": "Remove",
    "contributors.allReleases": "All Releases",
    "contributors.allRoles": "All Roles",
    "contributors.desc": "Manage your team, partners, and royalty splits.",
    "contributors.empty.desc": "No one matches your search criteria or you haven't added anyone yet.",
    "contributors.empty.title": "No Contributors Found",
    "contributors.errors.fillFields": "Please fill out all required fields.",
    "contributors.modal.cancel": "Cancel",
    "contributors.modal.email": "Email",
    "contributors.modal.name": "Full Name",
    "contributors.modal.release": "Associated Release (Optional)",
    "contributors.modal.role": "Role",
    "contributors.modal.save": "Save",
    "contributors.modal.split": "Split (%)",
    "contributors.modal.title": "Add New Contributor",
    "contributors.searchPlaceholder": "Search by name or email...",
    "contributors.stats.avgSplit": "Average Split",
    "contributors.stats.commonRole": "Most Common Role",
    "contributors.stats.total": "Total Contributors",
    "contributors.success.added": "Contributor added successfully!",
    "contributors.success.deleted": "Contributor deleted.",
    "contributors.success.invited": "Invite sent!",
    "contributors.title": "Contributor Manager",
    "feature.disabled": "Feature Disabled",
    "feature.disabledDesc": "This feature has been disabled for your account by the administrator. Contact support for more information.",
    "lyrics.aiGenerate": "AI Generate",
    "lyrics.aiGenerating": "Generating...",
    "lyrics.desc": "Manage, synchronize, and translate your lyrics.",
    "lyrics.editorSubtitle": "Lyrics Editor",
    "lyrics.empty.notFound": "No tracks found",
    "lyrics.emptyState.desc": "Select a track from the left to start editing.",
    "lyrics.emptyState.title": "Manage Your Lyrics",
    "lyrics.errors.aiFailed": "Error generating lyrics.",
    "lyrics.errors.loadFailed": "Error loading data.",
    "lyrics.errors.noLyrics": "No lyrics to export",
    "lyrics.errors.saveFailed": "Error saving.",
    "lyrics.errors.selectTrack": "Please select a track",
    "lyrics.export": "Export",
    "lyrics.labels.originalLang": "Original Language",
    "lyrics.labels.translationLang": "Translation (English)",
    "lyrics.placeholders.editor": "Write your lyrics here...",
    "lyrics.placeholders.translation": "Write translation here...",
    "lyrics.save": "Save",
    "lyrics.searchPlaceholder": "Search for a track or release...",
    "lyrics.stats.completion": "Completion",
    "lyrics.stats.totalTracks": "Total Tracks",
    "lyrics.success.aiGenerated": "AI lyrics generated!",
    "lyrics.success.downloaded": "downloaded!",
    "lyrics.success.saved": "Lyrics saved!",
    "lyrics.success.updated": "Lyrics updated!",
    "lyrics.synced.desc": "Coming soon! You'll be able to time each line while your song plays.",
    "lyrics.synced.title": "Synchronized Lyrics Mode",
    "lyrics.tabs.editor": "Text Editor",
    "lyrics.tabs.synced": "Synchronization",
    "lyrics.tabs.translation": "Translation",
    "lyrics.title": "Lyrics Manager",
    "mastering.acoustic": "Acoustic",
    "mastering.additionalProcessing": "Additional Processing",
    "mastering.advancedParams": "Advanced Parameters",
    "mastering.aiAnalyzing": "AI is Analyzing...",
    "mastering.aiDetected": "AI Detected",
    "mastering.aiRecommendations": "AI Recommendations",
    "mastering.analysis": "Analysis",
    "mastering.analyzing": "Analyzing...",
    "mastering.analyzingDesc": "Audio features, tempo, frequency distribution are being analyzed...",
    "mastering.audioFeatures": "Audio Features",
    "mastering.bass": "Bass (Low)",
    "mastering.brightness": "Brightness",
    "mastering.broadcast": "Broadcast",
    "mastering.broadcastDesc": "TV/Radio standards (-23 LUFS)",
    "mastering.cdQuality": "CD Quality",
    "mastering.cdQualityDesc": "Ideal for physical release (-12 LUFS)",
    "mastering.classical": "Classical",
    "mastering.clickToChangeFile": "MB — Click to choose another file",
    "mastering.clubDJ": "Club/DJ",
    "mastering.clubDJDesc": "For nightclub sound systems (-10 LUFS)",
    "mastering.completed": "Completed",
    "mastering.compression": "Compression",
    "mastering.confidence": "Confidence",
    "mastering.creditDeducted": "1 master credit will be deducted",
    "mastering.desc": "Automatic professional mastering with AI",
    "mastering.downloadFailed": "Download failed.",
    "mastering.downloadMaster": "Download Master",
    "mastering.downloading": "Downloading mastered file!",
    "mastering.dragDrop": "Drag & Drop",
    "mastering.dragDropClick": "Drag your song or click",
    "mastering.dynamicRange": "Dynamic Range",
    "mastering.edm": "EDM",
    "mastering.energyDistribution": "Energy Distribution",
    "mastering.eq": "Equalizer (EQ)",
    "mastering.errors.masterFailed": "Mastering failed",
    "mastering.errors.uploadFailed": "Upload failed",
    "mastering.fileConstraints": "WAV, MP3, FLAC, AIFF • Max 100MB",
    "mastering.flac": "FLAC",
    "mastering.flacDesc": "Lossless compression",
    "mastering.format": "Format",
    "mastering.genreAnalysis": "Genre Analysis",
    "mastering.hiphop": "Hip-Hop",
    "mastering.jazz": "Jazz",
    "mastering.lofi": "Lo-Fi",
    "mastering.loudMaster": "Loud Master",
    "mastering.loudMasterDesc": "High volume for maximum impact (-8 LUFS)",
    "mastering.masterTrack": "Master Track",
    "mastering.mastered": "Mastered",
    "mastering.masteringHistory": "Mastering History",
    "mastering.masteringPreset": "Mastering Preset",
    "mastering.masteringProcessing": "Mastering Processing...",
    "mastering.metal": "Metal",
    "mastering.metricsComp": "Metrics Comparison",
    "mastering.mixMastering": "Mix Mastering",
    "mastering.mp3_192": "MP3 192kbps",
    "mastering.mp3_192Desc": "Standard quality",
    "mastering.mp3_320": "MP3 320kbps",
    "mastering.mp3_320Desc": "High quality, small size",
    "mastering.newFile": "New File",
    "mastering.noHistory": "No mastering history yet.",
    "mastering.normal": "Normal",
    "mastering.normalDesc": "Standard AI Mastering",
    "mastering.optional": "(Optional)",
    "mastering.original": "Original",
    "mastering.outputFormat": "Output Format",
    "mastering.podcast": "Podcast",
    "mastering.pop": "Pop",
    "mastering.preset": "Preset",
    "mastering.processFailed": "AI Mastering failed.",
    "mastering.processSuccess": "AI Mastering completed!",
    "mastering.processing": "Processing",
    "mastering.processingDesc": "EQ, compressor, limiter, loudness normalization are being applied...",
    "mastering.refTrackAiNote": "AI will analyze and apply the tonal balance of this track",
    "mastering.refTrackUploadDesc": "Upload a reference track with your target sound profile",
    "mastering.refTrackUploaded": "Reference track uploaded",
    "mastering.reference": "Reference",
    "mastering.referenceTrack": "Reference Track",
    "mastering.resetToDefault": "Reset to Default",
    "mastering.reverb": "Reverb",
    "mastering.reverbDesc": "Lush reverb effect",
    "mastering.rnb": "R&B",
    "mastering.rock": "Rock",
    "mastering.saturation": "Saturation",
    "mastering.selectEffect": "Select Effect",
    "mastering.selectTarget": "Select target...",
    "mastering.slowed": "Slowed",
    "mastering.slowedDesc": "Slowed down (0.82x)",
    "mastering.slowedReverb": "Slowed + Reverb",
    "mastering.slowedReverbDesc": "Slow + reverb",
    "mastering.speedReverb": "Speed Up + Reverb",
    "mastering.speedReverbDesc": "Fast + reverb",
    "mastering.speedUp": "Speed Up",
    "mastering.speedUpDesc": "Sped up (1.25x)",
    "mastering.startAiMastering": "Start AI Mastering",
    "mastering.stepAnalyze": "AI Analysis",
    "mastering.stepDone": "Completed",
    "mastering.stepProcess": "Processing",
    "mastering.stepUpload": "Upload",
    "mastering.stereoWidth": "Stereo Width",
    "mastering.streaming": "Streaming",
    "mastering.streamingDesc": "Optimized for Spotify/Apple Music (-14 LUFS)",
    "mastering.subtitle": "Manual professional audio processing",
    "mastering.success.masteredDesc": "Your track is ready to download.",
    "mastering.success.masteredTitle": "Mastering complete!",
    "mastering.success.uploaded": "File uploaded and analyzed!",
    "mastering.title": "AI Mastering",
    "mastering.treble": "Treble (High)",
    "mastering.unsupportedFormat": "Unsupported file format.",
    "mastering.uploadFormat": "Upload your unmastered mix (WAV, FLAC, MP3)",
    "mastering.uploadTrack": "Upload Track",
    "mastering.vinyl": "Vinyl",
    "mastering.vinylDesc": "Warm analog feel, preserves dynamic range",
    "mastering.wav16": "WAV 16-bit",
    "mastering.wav16Desc": "CD quality",
    "mastering.wav24": "WAV 24-bit",
    "mastering.wav24Desc": "Highest quality, studio standard",
    "playlistExplorer.addedToFavs": "Added to favorites",
    "playlistExplorer.emptyDesc": "Use the search bar above to find playlists.",
    "playlistExplorer.emptyTitle": "Search or use filters",
    "playlistExplorer.filters": "Filters",
    "playlistExplorer.findSimilar": "Find Similar",
    "playlistExplorer.followers": "Followers",
    "playlistExplorer.genre": "Genre",
    "playlistExplorer.noFavs": "You don't have a favorite playlist yet.",
    "playlistExplorer.platform": "Platform",
    "playlistExplorer.removedFromFavs": "Removed from favorites",
    "playlistExplorer.risky": "Risky",
    "playlistExplorer.saveSearch": "Save Search",
    "playlistExplorer.search": "Search",
    "playlistExplorer.searchPlaceholder": "Search for a playlist, curator, or keyword...",
    "playlistExplorer.subtitle": "Find the most suitable playlists with advanced filters and AI",
    "playlistExplorer.tabExplore": "Explore",
    "playlistExplorer.tabFavorites": "Favorites",
    "playlistExplorer.tabSaved": "Saved Searches",
    "playlistExplorer.title": "Discover Playlists",
    "playlistExplorer.verified": "Verified",
    "playlistExplorer.applyTitle": "Playlist Application",
    "playlistExplorer.applySuccess": "Application submitted successfully!",
    "playlistExplorer.applyError": "Failed to submit application",
    "playlistExplorer.selectRelease": "Select Release",
    "playlistExplorer.pitchMessage": "Pitch Message (Optional)",
    "playlistExplorer.pitchPlaceholder": "Why does your release fit this playlist...",
    "playlistExplorer.sending": "Sending...",
    "playlistExplorer.send": "Send",
    "playlistExplorer.loadingReleases": "Loading releases...",
    "playlistExplorer.noReleases": "No releases found.",
    "playlistExplorer.apply": "Apply",
    "playlistExplorer.applyTitle": "Playlist Application",
    "playlistExplorer.applySuccess": "Application submitted successfully!",
    "playlistExplorer.applyError": "Failed to submit application",
    "playlistExplorer.selectRelease": "Select Release",
    "playlistExplorer.pitchMessage": "Pitch Message (Optional)",
    "playlistExplorer.pitchPlaceholder": "Why does your release fit this playlist...",
    "playlistExplorer.sending": "Sending...",
    "playlistExplorer.send": "Send",
    "playlistExplorer.loadingReleases": "Loading releases...",
    "playlistExplorer.noReleases": "No releases found.",
    "preSave.appleMusicId": "Apple Music ID",
    "preSave.applePlaceholder": "123456789",
    "preSave.spotifyPlaceholder": "spotify:album:...",
    "preSave.spotifyUri": "Spotify URI",
    "promotions.artist": "Artist",
    "promotions.download": "Download",
    "promotions.downloadInstructions": "Click on a card to download.",
    "promotions.downloading": "Downloading...",
    "promotions.generating": "Generating promotion cards...",
    "promotions.generatingWait": "This process may take a few seconds",
    "promotions.noApprovedRelease": "No approved releases yet",
    "promotions.noApprovedReleaseDesc": "Promotion cards will appear here once your release is live.",
    "promotions.noRelease": "No published releases yet",
    "promotions.selectPlaceholder": "Select a release...",
    "promotions.selectReleaseDesc": "Create eye-catching visuals with templates.",
    "promotions.selectReleasePrompt": "Select a release to view promotion cards",
    "promotions.statusApproved": "Approved",
    "promotions.statusLive": "Live",
    "promotions.subtitle": "Select your release and download high-resolution promotional cards.",
    "promotions.title": "Promotion Cards",
    "promotions.untitled": "Untitled",
    "promotions.untitledTrack": "Untitled Track",
    "qr.cancel": "Cancel",
    "qr.createError": "Failed to create QR code",
    "qr.createSuccess": "QR Code created successfully",
    "qr.deleteError": "Failed to delete QR code",
    "qr.deleteSuccess": "QR Code deleted successfully",
    "qr.fetchError": "Failed to fetch QR codes",
    "qr.formTitle": "Title",
    "qr.requiredFields": "Title and URL are required",
    "qr.subtitle": "Create and manage custom QR codes for your content",
    "qr.titlePlaceholder": "e.g. Summer Tour 2024",
    "smartLinks.basicInfo": "Basic Info",
    "smartLinks.customSlug": "Custom Slug",
    "smartLinks.slugPlaceholder": "my-new-single",
    "smartLinks.titlePlaceholder": "e.g. My New Single",
    "splits.accept": "Accept",
    "splits.activeSplits": "Active Splits",
    "splits.chooseLiveRelease": "Choose a live release",
    "splits.contributing": "Contributing",
    "splits.contributingTo": "Contributing to Split",
    "splits.createBtn": "Create New Split",
    "splits.createModalDesc": "Select a live release to create a revenue split",
    "splits.createModalTitle": "Create Revenue Split",
    "splits.currentBalance": "Current Balance",
    "splits.decline": "Decline",
    "splits.earningsByTrack": "Earnings by Track",
    "splits.errorCreate": "Failed to create split",
    "splits.errorLoad": "Failed to load splits data",
    "splits.errorNoTrack": "No track found in this release",
    "splits.errorRespond": "Failed to respond",
    "splits.errorSelectRelease": "Please select a release",
    "splits.from": "From:",
    "splits.inviteAccepted": "Invite accepted!",
    "splits.inviteDeclined": "Invite declined",
    "splits.live": "Live",
    "splits.mySplits": "My Splits",
    "splits.noContributingSplits": "You're not contributing to any splits yet.",
    "splits.noContributingSplitsDesc": "Accept invitations from other artists to start earning.",
    "splits.noLiveReleases": "You need at least one live release to create revenue splits.",
    "splits.noOwnedSplits": "You haven't created any revenue splits yet.",
    "splits.noOwnedSplitsDesc": "Add collaborators when uploading a track to share revenue.",
    "splits.onlyLiveReleases": "Only live releases can have revenue splits",
    "splits.owner": "Owner:",
    "splits.pendingInvitations": "Pending Invitations",
    "splits.pendingInvitationsDesc": "You have pending revenue split invitations",
    "splits.roleContributor": "Contributor",
    "splits.roleFeaturedArtist": "Featured Artist",
    "splits.roleProducer": "Producer",
    "splits.roleSongwriter": "Songwriter",
    "splits.selectRelease": "Select Release *",
    "splits.subtitle": "Manage revenue sharing with collaborators",
    "splits.successCreated": "Revenue split created successfully!",
    "splits.title": "Revenue Splits",
    "splits.totalEarned": "Total Earned",
    "splits.trackId": "Track ID:",
    "splits.trackSplit": "Track Split",
    "splits.untitled": "Untitled",
    "splits.you": "(You)",
    "splits.yourShare": "Your Share",
    "subscription.advanced": "Advanced",
    "subscription.artistDesc": "For serious artists",
    "subscription.basic": "Basic",
    "subscription.choosePlan": "Choose Your Plan",
    "subscription.commission": "Commission",
    "subscription.contactSupport": "Contact our support team if you have any questions.",
    "subscription.contactSupportBtn": "Contact Support",
    "subscription.currentPlan": "Current Plan:",
    "subscription.currentPlanBtn": "Current Plan",
    "subscription.days25": "2-5 days",
    "subscription.downgrade": "Downgrade",
    "subscription.email": "Email",
    "subscription.fastDelivery": "Fast delivery",
    "subscription.featAnalytics": "Analytics",
    "subscription.featCommission": "Commission Rate",
    "subscription.featDelivery": "Delivery Time",
    "subscription.featMultiArtist": "Multiple Artists",
    "subscription.featReleaseLimit": "Release Limit",
    "subscription.featSplits": "Split System",
    "subscription.featSupport": "Support",
    "subscription.feature": "Feature",
    "subscription.featureComparison": "Feature Comparison",
    "subscription.free": "Free",
    "subscription.freeDesc": "Start your music journey",
    "subscription.haveQuestions": "Have questions?",
    "subscription.hours2472": "24-72 hours",
    "subscription.labelDesc": "For labels and managers",
    "subscription.month": "mo",
    "subscription.paymentSoon": "Payment integration coming soon! Contact support to upgrade.",
    "subscription.popular": "Popular",
    "subscription.priority": "Priority",
    "subscription.release": "Release",
    "subscription.save17": "save 17%",
    "subscription.subtitle": "Choose the plan that fits your needs.",
    "subscription.title": "Grow Your Music Career",
    "subscription.unlimited": "Unlimited",
    "subscription.upgrade": "Upgrade",
    "subscription.year": "yr",
    "subscription.yearlyOr": "or",
    "viral.activeCampaigns": "Active Campaigns",
    "viral.activeCampaignsList": "Active Campaigns",
    "viral.aiPlanning": "AI is Planning...",
    "viral.aiPlanningDesc": "The best viral strategy is being created.",
    "viral.back": "Back",
    "viral.campaignCreateError": "Error creating campaign.",
    "viral.campaignLive": "Campaign is Live!",
    "viral.campaignLiveDesc": "Your campaign was successfully created.",
    "viral.campaignPage": "Campaign Page",
    "viral.campaignSuccess": "Campaign successfully launched!",
    "viral.cancel": "Cancel",
    "viral.clicks": "Clicks",
    "viral.contentCount": "Content Count",
    "viral.contentIdeas": "Content Ideas",
    "viral.continue": "Continue",
    "viral.copied": "Copied",
    "viral.copy": "Copy",
    "viral.createAIPlan": "Generate AI Plan",
    "viral.createNewCampaign": "Create New Campaign",
    "viral.desc": "Create step-by-step engagement and marketing plans powered by AI.",
    "viral.engagementRate": "Engagement Rate",
    "viral.estReach": "Estimated Reach",
    "viral.globalImpactMap": "Global Impact Map",
    "viral.hashtagDesc": "Build a community around a specific tag",
    "viral.hashtagName": "Hashtag Campaign",
    "viral.launchCampaign": "Launch Campaign",
    "viral.launching": "Launching",
    "viral.linkCopied": "Link copied!",
    "viral.listeningDesc": "Synchronous online listening event with fans",
    "viral.listeningName": "Listening Party",
    "viral.noActiveCampaigns": "No active campaigns yet.",
    "viral.noActiveCampaignsDesc": "Use the wizard to create your first campaign.",
    "viral.noReleases": "You don't have any approved releases yet.",
    "viral.noReleasesDesc": "Create a release first to start a campaign.",
    "viral.planError": "Error generating plan",
    "viral.platformLinks": "Platform Links",
    "viral.platformLinksDesc": "Enter the links where listeners will access your song",
    "viral.presaveDesc": "Get listeners to pre-save your release",
    "viral.presaveName": "Pre-Save Campaign",
    "viral.progress": "Progress",
    "viral.release": "Release",
    "viral.selectCampaignType": "Select Campaign Type",
    "viral.selectCampaignTypeDesc": "Determine the marketing strategy that best fits your goal.",
    "viral.selectRelease": "Select Target Release",
    "viral.selectReleaseDesc": "Which song do you want to create a campaign for?",
    "viral.stepAIPlan": "AI Plan",
    "viral.stepLaunch": "Launch",
    "viral.stepRelease": "Release",
    "viral.stepType": "Type",
    "viral.task": "Task",
    "viral.teaserDesc": "A series of intriguing pre-release content",
    "viral.teaserName": "Teaser",
    "viral.tiktokDesc": "Engage users with a dance or trend",
    "viral.tiktokName": "TikTok Challenge",
    "viral.timeline": "Timeline",
    "viral.title": "Viral Campaign",
    "viral.totalCampaigns": "Total Campaigns",
    "viral.totalViews": "Total Views",
    "viral.unknownRelease": "Unknown Release",
    "viral.viewCampaignPage": "View Campaign Page",
    "viral.views": "Views",

  
  
  
    "email.subject_placeholder": "Subject...",
    "social.error_content_required": "Content is required",
    "copyright.analyzing": "Analyzing...",
    "copyright.totalScans": "Total Scans",
    "email.name_placeholder": "Name...",
    "lyricsSync.lyricsPlaceholder": "Enter Lyrics Here Line by Line...",
    "social.create_first": "Create First Post",
    "email.error_deleting_subscriber": "Error deleting subscriber",
    "email.campaign_created": "Campaign created",
    "copyright.supportedFormats": "Supported Formats",
    "preSave.requiredFields": "Please fill all required fields",
    "email.subscriber_deleted": "Subscriber deleted",
    "preSave.confirmDelete": "Are you sure you want to delete this campaign?",
    "social.error_delete": "Error deleting post",
    "email.email_placeholder": "Email...",
    "releases.fetchFailed": "Failed to fetch releases",
    "email.fill_required": "Please fill all required fields",
    "toast.releaseSubmitFailed": "Failed to submit release",
    "preSave.fetchError": "Failed to load data",
    "_": "_",
    "email.click_rate": "Click Rate",
    "common.saving": "Saving...",
    "aiStudio.alreadyAnalyzed": "This file has already been analyzed",
    "email.subscribers_list": "Subscribers List",
    "copyright.recentScans": "Recent Scans",
    ".": ".",
    "support.faq": "FAQ",
    "email.add": "Add",
    "pressKit.success.upload": "Successfully uploaded",
    "email.status": "Status",
    "copyright.startScanBtn": "Start Scan",
    "error": "Error",
    "contributors.errors.deleteFailed": "Failed to delete contributor",
    "support.submit": "Submit",
    "album": "Album",
    "email.error_creating_campaign": "Error creating campaign",
    "email.no_subscribers": "No subscribers",
    "releases.deleteSuccess": "Release deleted successfully",
    "referrals.error": "Referral error",
    "common.title": "Title",
    "social.confirm_delete": "Are you sure you want to delete?",
    "pressKit.subtitle": "Electronic Press Kit",
    "pressKit.error.maxPhotos": "Maximum photos reached",
    "email.error_adding_subscriber": "Error adding subscriber",
    "email.error_fetching": "Error fetching data",
    "social.updated": "Updated successfully",
    "promotions.errorGenerating": "Failed to generate promotion cards",
    "collab.cancel": "Cancel",
    "common.yesDelete": "Yes, Delete",
    "social.empty_desc": "No posts found",
    "common.continue": "Continue",
    "email.campaign_sent": "Campaign sent",
    "SRT": "SRT",
    "email.email": "Email",
    "pressKit.error.upload": "Error uploading",
    "TXT": "TXT",
    "social.error_upload": "Error uploading media",
    "campaigns.all": "All Campaigns",
    "copyright.error.noFile": "No file selected",
    "ref": "Reference",
    "common.select": "Select",
    "copyright.scanStarted": "Scan started",
    "social.status": "Status",
    "copyright.noDetails": "No details available",
    "script": "Script",
    "lyricsSync.description": "Create Time-Synced Lyrics for Your Songs",
    "aiStudio.maintenanceDesc": "This feature is currently under maintenance. It will be available again soon.",
    "lyricsSync.previewEmpty": "Preview Will Appear Here",
    "aiAdvisor.exportFileName": "advisor_export",
    "copyright.uploadFile": "Upload File",
    "email.import_error": "Error importing",
    "error.fetch": "Fetch error",
    "copyright.subtitle": "Copyright Management",
    "wizard.moreOptions.ownershipConfirmation": "Ownership Confirmation",
    "social.media": "Social Media",
    "lyricsSync.saveSuccess": "Lyrics Saved Successfully",
    "common.verifying": "Verifying...",
    "preSave.deleteError": "Failed to delete campaign",
    "smartLinks.uploadCover": "Click to upload cover image",
    "lyricsSync.selectTrackLabel": "Select Track",
    "smartLinks.uploadBg": "Upload background image (optional)",
    "lyricsSync.noAudio": "No audio file found for this track. Sync might not work properly.",
    "social.error_save": "Error saving post",
    "support.attachments": "Attachments",
    "common.or": "Or",
    "email.no_campaigns": "No campaigns",
    "email.import_success": "Imported successfully",
    "pressKit.error.load": "Error loading press kit",
    "pressKit.assets": "Assets",
    "promotions.downloadError": "Download failed",
    "preSave.copied": "Copied",
    "email.total_subscribers": "Total Subscribers",
    "pressKit.noReleases": "No releases",
    "email.save_draft": "Save Draft",
    "preSave.createFirst": "Create First Campaign",
    "copyright.cleanDesc": "Clean tracks description",
    "preSave.createSuccess": "Campaign created successfully",
    "lyricsSync.allSynced": "All Lines Synced!",
    "copyright.error.noTrack": "No track selected",
    "lyricsSync.saveError": "Failed to Save Lyrics",
    "playlistExplorer.all": "All Playlists",
    "contributors.errors.loadFailed": "Failed to load contributors",
    "pressKit.error.save": "Error saving press kit",
    "email.error_sending_campaign": "Error sending campaign",
    "releaseForm.selectGenre": "Select Genre",
    "playlistExplorer.errorFetching": "Error fetching playlists",
    "aiStudio.maintenance": "Under Maintenance",
    "social.error_fetch": "Error fetching posts",
    "none": "None",
    "smartLinks.error.fetch": "Failed to fetch smart links",
    "preSave.deleteSuccess": "Campaign deleted",
    "social.editPost": "Edit Post",
    "promotions.downloadSuccess": "Promotion card downloaded!",
    "smartLinks.error.create": "Failed to create smart link",
    "contributors.errors.saveFailed": "Failed to save contributor",
    "smartLinks.confirm.delete": "Are you sure you want to delete this smart link?",
    "email.error_deleting_campaign": "Error deleting campaign",
    "email.date": "Date",
    "social.error_platform_required": "Platform is required",
    "smartLinks.error.required": "Title and slug are required",
    "social.created": "Post created",
    "2d": "2D",
    "copyright.chooseTrack": "Choose Track",
    "social.error_date_required": "Date is required",
    "copyright.scanFailed": "Scan failed",
    "copyright.flaggedTracks": "Flagged Tracks",
    "pressKit.bioPlaceholder": "Bio...",
    "status.pending": "Pending",
    "social.deleted": "Post deleted",
    "email.create_campaign": "Create Campaign",
    "smartLinks.success.created": "Smart link created successfully",
    "T": "T",
    "canvas": "Canvas",
    "email.actions": "Actions",
    "smartLinks.error.delete": "Failed to delete smart link",
    "a": "a",
    "support.guides": "Guides",
    "social.image_uploaded": "Image uploaded",
    "pressKit.success.save": "Saved successfully",
    "email.open_rate": "Open Rate",
    "preSave.chooseRelease": "Choose release...",
    "support.searchTickets": "Search tickets...",
    "copyright.startNewScan": "Start New Scan",
    "copyright.dragDrop": "Drag and Drop",
    "single": "Single",
    "email.content_placeholder": "Content...",
    "preSave.createError": "Failed to create campaign",
    "-": "-",
    "email.campaign_deleted": "Campaign deleted",
    "token": "Token",
    "playlistExplorer.apply": "Apply",
    "common.verify": "Verify",
    "smartLinks.success.deleted": "Smart link deleted",
    "wizard.moreOptions.contentIdTerms": "Content ID Terms",
    "social.subtitle": "Social Media Dashboard",
    "status.scheduled": "Scheduled",
    "copyright.cleanRate": "Clean Rate",
    "email.subscriber_added": "Subscriber added",
    "fanScore.fetchError": "Failed to fetch fan score",
    "LRC": "LRC",
    // admin.announcements
    "admin.announcements.title": "Announcements",
    "admin.announcements.subtitle": "Manage announcements shown to users",
    "admin.announcements.newAnnouncement": "New Announcement",
    "admin.announcements.noAnnouncements": "No announcements yet",
    "admin.announcements.titleBodyRequired": "Title and content are required",
    "admin.announcements.updated": "Announcement updated",
    "admin.announcements.operationFailed": "Operation failed",
    "admin.announcements.deleted": "Announcement deleted",
    "admin.announcements.deleteFailed": "Delete operation failed",
    "admin.announcements.deactivated": "Announcement deactivated",
    "admin.announcements.activated": "Announcement activated",
    "admin.announcements.active": "Active",
    "admin.announcements.inactive": "Inactive",
    "admin.announcements.createdAt": "Created",
    "admin.announcements.start": "Start",
    "admin.announcements.end": "End",
    "admin.announcements.deactivate": "Deactivate",
    "admin.announcements.activate": "Activate",
    "admin.announcements.titleLabel": "Title",
    "admin.announcements.titlePlaceholder": "Announcement title",
    "admin.announcements.contentLabel": "Content",
    "admin.announcements.contentPlaceholder": "Announcement content",
    "admin.announcements.type": "Type",
    "admin.announcements.typeInfo": "Info",
    "admin.announcements.typeWarning": "Warning",
    "admin.announcements.typeSuccess": "Success",
    "admin.announcements.displayMode": "Display Mode",
    "admin.announcements.both": "Both",
    "admin.announcements.startDateOptional": "Start Date (optional)",
    "admin.announcements.endDateOptional": "End Date (optional)",
    "admin.announcements.pinned": "Pinned",
    "admin.announcements.activeLabel": "Active",

    // admin.aiMatcher
    "admin.aiMatcher.title": "AI Matcher Results",
    "admin.aiMatcher.subtitle": "Users' AI Playlist Matcher match history",
    "admin.aiMatcher.totalResults": "Total",
    "admin.aiMatcher.results": "results",
    "admin.aiMatcher.noResults": "No match results yet",
    "admin.aiMatcher.resultDeleted": "Result deleted",
    "admin.aiMatcher.resultDeleteFailed": "Failed to delete result",
    "admin.aiMatcher.user": "User",
    "admin.aiMatcher.release": "Release",
    "admin.aiMatcher.genre": "Genre",
    "admin.aiMatcher.match": "Match",
    "admin.aiMatcher.score": "Score",
    "admin.aiMatcher.date": "Date",
    "admin.aiMatcher.actions": "Actions",
    "admin.aiMatcher.matchedPlaylists": "Matched Playlists",
    "admin.aiMatcher.followers": "followers",
    "admin.releaseDetail.fetchFailed": "Failed to fetch release details",
    "admin.releaseDetail.reasonNeeded": "Reason is required for this status",
    "admin.releaseDetail.statusUpdated": "Status updated",
    "admin.releaseDetail.updateFailed": "Update failed",
    "admin.releaseDetail.codesSaved": "Codes saved",
    "admin.releaseDetail.saveFailed": "Save failed",
    "admin.releaseDetail.packageDownloading": "Package downloading...",
    "admin.releaseDetail.releaseUpdated": "Release updated",
    "admin.releaseDetail.metadataDownloaded": "Metadata downloaded",
    "admin.releaseDetail.dspSummary": "DSP Summary",
    "admin.releaseDetail.editAll": "Edit All",
    "admin.releaseDetail.changeStatus": "Change Status",
    "admin.releaseDetail.updateStatus": "Update Status",
    "admin.releaseDetail.selectTemplate": "Select Template",
    "admin.releaseDetail.templatePlaceholder": "Select template or write custom message...",
    "admin.releaseDetail.templateHint": "If you select a template, the message will be auto-filled and you can edit it.",
    "admin.releaseDetail.update": "Update",
    "admin.releaseDetail.editCodes": "Edit ISRC & UPC Codes",
    "admin.releaseDetail.upcCode": "UPC (Release Code)",
    "admin.releaseDetail.enterUpc": "Enter UPC code",
    "admin.releaseDetail.barcodeHint": "12-digit barcode number",
    "admin.releaseDetail.isrcCodes": "ISRC Codes (Per Track)",
    "admin.releaseDetail.enterIsrc": "Enter ISRC code (e.g.: USRC17607839)",
    "admin.releaseDetail.isrcFormat": "ISRC format: CC-XXX-YY-NNNNN",
    "admin.releaseDetail.editRelease": "Edit Release",
    "admin.releaseDetail.general": "General",
    "admin.releaseDetail.tracks": "Tracks",
    "admin.releaseDetail.publishing": "Publishing",
    "admin.releaseDetail.platforms": "Platforms",
    "admin.releaseDetail.links": "Links",
    "admin.releaseDetail.releaseType": "Release Type",
    "admin.releaseDetail.releaseDate": "Release Date",
    "admin.releaseDetail.albumTitle": "Album Title",
    "admin.releaseDetail.albumVersion": "Album Version",
    "admin.releaseDetail.versionPlaceholder": "Deluxe, Remastered, etc.",
    "admin.releaseDetail.primaryGenre": "Primary Genre",
    "admin.releaseDetail.secondaryGenre": "Secondary Genre",
    "admin.releaseDetail.language": "Language",
    "admin.releaseDetail.labelCompany": "Label / Company",
    "admin.releaseDetail.barcodeShort": "12-digit barcode",
    "admin.releaseDetail.barcodePlaceholder": "12-digit barcode",
    "admin.releaseDetail.releaseTime": "Release Time",
    "admin.releaseDetail.select": "Select",
    "admin.releaseDetail.localTime": "Local Time",
    "admin.releaseDetail.previouslyReleased": "Previously released",
    "admin.releaseDetail.originalReleaseDate": "Original Release Date",
    "admin.releaseDetail.untitledTrack": "Untitled Track",
    "admin.releaseDetail.trackTitle": "Track Title",
    "admin.releaseDetail.version": "Version",
    "admin.releaseDetail.versionExamples": "Remix, Acoustic, etc.",
    "admin.releaseDetail.albumVersionPlaceholder": "Deluxe, Remastered, etc.",
    "admin.releaseDetail.contentType": "Content Type",
    "admin.releaseDetail.notSpecified": "Not specified",
    "admin.releaseDetail.primaryArtistsComma": "Primary Artists (comma separated)",
    "admin.releaseDetail.featuredArtistsComma": "Featured Artists (comma separated)",
    "admin.releaseDetail.spotifyArtistIds": "Spotify Artist IDs",
    "admin.releaseDetail.primaryArtists": "Primary Artists",
    "admin.releaseDetail.spotifyIdNotLinked": "Spotify ID not linked - Artists",
    "admin.releaseDetail.featuredArtists": "Featured Artists",
    "admin.releaseDetail.writers": "Writers",
    "admin.releaseDetail.composers": "Composers",
    "admin.releaseDetail.producers": "Producers",
    "admin.releaseDetail.songwritersFormat": "Songwriters (Name (Role), format)",
    "admin.releaseDetail.contributors": "Contributors",
    "admin.releaseDetail.productionTeam": "Production Team",
    "admin.releaseDetail.instrumental": "Instrumental",
    "admin.releaseDetail.licensedContent": "Licensed Content",
    "admin.releaseDetail.lyrics": "Lyrics",
    "admin.releaseDetail.enterLyrics": "Enter lyrics...",
    "admin.releaseDetail.lyricsPlaceholder": "Enter lyrics...",
    "admin.releaseDetail.publishingInfo": "Publishing Information",
    "admin.releaseDetail.publishingPercentage": "Publishing Percentage (%)",
    "admin.releaseDetail.hasPublisher": "I have a publisher",
    "admin.releaseDetail.publisherName": "Publisher Name",
    "admin.releaseDetail.proInfo": "PRO Information",
    "admin.releaseDetail.registeredWithPro": "Registered with PRO",
    "admin.releaseDetail.affiliatedSociety": "Affiliated Society",
    "admin.releaseDetail.ipiNumber": "IPI Number",
    "admin.releaseDetail.distributionPlatforms": "Distribution Platforms",
    "admin.releaseDetail.platformLinks": "Platform Links",
    "admin.releaseDetail.dspDescription": "All track metadata information. Use for manual DSP upload.",
    "admin.releaseDetail.dspMetadataDesc": "All track metadata information. Use for manual DSP upload.",
    "admin.releaseDetail.releaseVersion": "Release Version",
    "admin.releaseDetail.albumArtists": "Album Artists",
    "admin.releaseDetail.date": "Date",
    "admin.releaseDetail.trackCount": "Track Count",
    "admin.releaseDetail.transferInfo": "Transfer Information",
    "admin.releaseDetail.distributionType": "Distribution Type",
    "admin.releaseDetail.transferFrom": "Transfer (From Another Distributor)",
    "admin.releaseDetail.transferDistribution": "Transfer (From Another Distributor)",
    "admin.releaseDetail.newRelease": "New Release",
    "admin.releaseDetail.trackVersion": "Track Version",
    "admin.releaseDetail.existingIsrc": "Existing ISRC",
    "admin.releaseDetail.fileName": "File Name",
    "admin.releaseDetail.duration": "Duration",
    "admin.releaseDetail.trackVersionFull": "Track Version",
    "admin.releaseDetail.trackLanguage": "Track Language",
    "admin.releaseDetail.titleLanguage": "Title Language",
    "admin.releaseDetail.genre": "Genre",
    "admin.releaseDetail.recordLabel": "Record Label",
    "admin.releaseDetail.credits": "Credits",
    "admin.releaseDetail.creditInfo": "Credits",
    "admin.releaseDetail.songwriters": "Songwriters / Composers",
    "admin.releaseDetail.songwritersSection": "Songwriters / Composers",
    "admin.releaseDetail.name": "Name",
    "admin.releaseDetail.role": "Role",
    "admin.releaseDetail.productionTeamFull": "Production Team",
    "admin.releaseDetail.productionTeamSection": "Production Team",
    "admin.releaseDetail.contributorsFull": "Contributors",
    "admin.releaseDetail.contributorsSection": "Contributors",
    "admin.releaseDetail.noCreditWarning": "No credit information entered for this track",
    "admin.releaseDetail.writersLegacy": "Writers (Legacy)",
    "admin.releaseDetail.composersLegacy": "Composers (Legacy)",
    "admin.releaseDetail.producersLegacy": "Producers (Legacy)",
    "admin.releaseDetail.downloadLicense": "Download License (PDF)",
    "admin.releaseDetail.licenseNotUploaded": "License document not uploaded!",
    "admin.releaseDetail.noLicenseUploaded": "License document not uploaded!",
    "admin.releaseDetail.lyricsLanguage": "Language",
    "admin.releaseDetail.viewLyrics": "View Lyrics",
    "admin.releaseDetail.noLyricsEntered": "No lyrics entered",
    "admin.releaseDetail.lyricsDspNote": "Lyrics can be displayed on DSPs like Apple Music, Spotify, etc.",
    "admin.releaseDetail.lyricsVisibleOnDsp": "Lyrics can be displayed on DSPs like Apple Music, Spotify, etc.",
    "admin.releaseDetail.noTracks": "No tracks",
    "admin.releaseDetail.contributorsTitle": "Contributors",
    "admin.releaseDetail.producersLabel": "Producers",
    "admin.releaseDetail.platformsTitle": "Platforms",
    "admin.releaseDetail.images": "Images",
    "admin.releaseDetail.coverImages": "Images",
    "admin.releaseDetail.linksTitle": "Links",
    "admin.releaseDetail.pricing": "Pricing",
    "admin.releaseDetail.singlePrice": "Single Price",
    "admin.releaseDetail.albumPrice": "Album Price",
    "admin.releaseDetail.uploadDate": "Upload",
    "admin.artists.loadFailed": "Failed to load user details",
    "admin.artists.featureUpdated": "Feature updated",
    "admin.artists.featureUpdateFailed": "Feature update failed",
    "admin.artists.ibanRevealed": "IBAN revealed - Logged to audit log",
    "admin.artists.ibanNotFound": "IBAN information not found",
    "admin.artists.superadminRequired": "Superadmin permission required",
    "admin.artists.ibanRevealFailed": "Failed to reveal IBAN",
    "admin.artists.copiedToClipboard": "Copied to clipboard",
    "admin.artists.userApproved": "User approved",
    "admin.artists.rejectReasonMandatory": "Rejection reason is required",
    "admin.artists.rejectReasonRequired": "Rejection reason is required",
    "admin.artists.userRejected": "User rejected",
    "admin.artists.banReasonMandatory": "Ban reason is required",
    "admin.artists.banReasonRequired": "Ban reason is required",
    "admin.artists.userBanned": "User banned",
    "admin.artists.banRemoved": "Ban removed",
    "admin.artists.planUpdated": "Plan updated",
    "admin.artists.badgesUpdated": "Badges updated",
    "admin.artists.enterValidAmount": "Enter a valid amount",
    "admin.artists.addedByAdmin": "Added by admin",
    "admin.artists.balanceUpdated": "Balance updated",
    "admin.artists.operationFailed": "Operation failed",
    "admin.artists.passwordMinLength": "Password must be at least 6 characters",
    "admin.artists.passwordResetSuccess": "Password reset successfully",
    "admin.artists.passwordResetFailed": "Password reset failed",
    "admin.artists.passwordCopied": "Password copied to clipboard",
    "admin.artists.title": "Artist Management",
    "admin.artists.subtitle": "Manage and approve users",
    "admin.artists.userNotFound": "No users found",
    "admin.artists.noUsersFound": "No users found",
    "admin.artists.noUsersForFilter": "No users found for the selected filter.",
    "admin.artists.user": "User",
    "admin.artists.balanceHeader": "Balance",
    "admin.artists.status": "Status",
    "admin.artists.registrationDate": "Registration Date",
    "admin.artists.actions": "Actions",
    "admin.artists.detail": "Detail",
    "admin.artists.approve": "Approve",
    "admin.artists.reject": "Reject",
    "admin.artists.balanceBtn": "Balance",
    "admin.artists.balanceAction": "Balance",
    "admin.artists.ban": "Ban",
    "admin.artists.unban": "Remove Ban",
    "admin.artists.approveUser": "Approve User",
    "admin.artists.approveUserDialog": "Approve User",
    "admin.artists.rejectUser": "Reject User",
    "admin.artists.rejectUserDialog": "Reject User",
    "admin.artists.banUser": "Ban User",
    "admin.artists.banUserDialog": "Ban User",
    "admin.artists.unbanUserDialog": "Remove Ban",
    "admin.artists.assignPlan": "Assign Plan",
    "admin.artists.assignPlanDialog": "Assign Plan",
    "admin.artists.addBalance": "Add Balance",
    "admin.artists.addBalanceDialog": "Add Balance",
    "admin.artists.currentBanReason": "Current ban reason",
    "admin.artists.noteOptional": "Note (Optional)",
    "admin.artists.notePlaceholder": "Note to send to the user...",
    "admin.artists.rejectReasonLabel": "Rejection Reason (Required)",
    "admin.artists.rejectReasonPlaceholder": "Specify the rejection reason...",
    "admin.artists.banReasonLabel": "Ban Reason (Required)",
    "admin.artists.banReasonPlaceholder": "E.g.: Copyright violation, license verification pending...",
    "admin.artists.bannedUserRestrictions": "Banned users cannot submit new releases or request payouts.",
    "admin.artists.banWarning": "Banned users cannot submit new releases or request payouts.",
    "admin.artists.unbanNotePlaceholder": "Unban note...",
    "admin.artists.planType": "Plan Type",
    "admin.artists.selectPlan": "Select plan",
    "admin.artists.amount": "Amount ($)",
    "admin.artists.amountLabel": "Amount ($)",
    "admin.artists.amountPlaceholder": "E.g.: 100.00",
    "admin.artists.description": "Description",
    "admin.artists.descriptionLabel": "Description",
    "admin.artists.descriptionPlaceholder": "E.g.: Streaming earnings",
    "admin.artists.banAction": "Ban",
    "admin.artists.unbanAction": "Remove Ban",
    "admin.artists.add": "Add",
    "admin.artists.userDetails": "User Details",
    "admin.artists.basicInfo": "Basic Information",
    "admin.artists.fullName": "Full Name",
    "admin.artists.email": "Email",
    "admin.artists.addressInfo": "Address Information",
    "admin.artists.address": "Address",
    "admin.artists.city": "City",
    "admin.artists.country": "Country",
    "admin.artists.postalCode": "Postal Code",
    "admin.artists.loginInfo": "Login Info & IP Addresses",
    "admin.artists.loginAndIpInfo": "Login Info & IP Addresses",
    "admin.artists.registrationDateLabel": "Registration Date",
    "admin.artists.lastLogin": "Last Login",
    "admin.artists.lastLoginIp": "Last Login IP",
    "admin.artists.loginHistory": "Login History (Last 10)",
    "admin.artists.billingProfile": "Billing & Payout Profile",
    "admin.artists.billingAndPayoutProfile": "Billing & Payout Profile",
    "admin.artists.payoutMethodFull": "Payment Method (Full Details)",
    "admin.artists.bankTransfer": "Bank Transfer",
    "admin.artists.lastUpdate": "Last update",
    "admin.artists.lastUpdated": "Last updated",
    "admin.artists.statistics": "Statistics",
    "admin.artists.stats": "Statistics",
    "admin.artists.totalReleases": "Total Releases",
    "admin.artists.supportTickets": "Support Tickets",
    "admin.artists.payoutRequests": "Payout Requests",
    "admin.artists.banInfo": "Ban Information",
    "admin.artists.banReason": "Ban Reason",
    "admin.artists.banReasonDetail": "Ban Reason",
    "admin.artists.notSpecified": "Not specified",
    "admin.artists.banDate": "Ban Date",
    "admin.artists.referralInfo": "Referral Information",
    "admin.artists.referralCode": "Referral Code",
    "admin.artists.featureControl": "Feature Control (Disable)",
    "admin.artists.off": "(Off)",
    "admin.artists.on": "(On)",
    "admin.artists.adminFullAccess": "As an admin, you have full access to all payment information.",
    "admin.artists.adminPaymentAccess": "As an admin, you have full access to all payment information.",
    "admin.artists.noPayoutMethod": "No payment method defined",
    "admin.artists.paymentMethodNotDefined": "No payment method defined",
    "admin.artists.resetPassword": "Reset Password",
    "admin.artists.resetPasswordBtn": "Reset Password",
    "admin.artists.resetPasswordTitle": "Reset Password",
    "admin.artists.setNewPassword": "set a new password for",
    "admin.artists.setNewPasswordFor": "set a new password for",
    "admin.artists.newPassword": "New Password",
    "admin.artists.enterNewPassword": "Enter new password",
    "admin.artists.newPasswordPlaceholder": "Enter new password",
    "admin.artists.minChars": "Must be at least 6 characters",
    "admin.artists.min6Chars": "Must be at least 6 characters",
    "admin.artists.forcePasswordChange": "Force user to change password on first login",
    "admin.artists.generatedPassword": "Generated password",
    "admin.artists.resetPasswordAction": "Reset Password",
    "admin.artists.resetPasswordConfirm": "Reset Password",
    "admin.artists.auditLog": "Payment Transaction History (Audit Log)",
    "admin.payoutMethods.loadFailed": "Failed to load payout methods",
    "admin.payoutMethods.revealFailed": "Failed to reveal details",
    "admin.payoutMethods.billingLoadFailed": "Failed to load billing profile",
    "admin.payoutMethods.noUserSelected": "No user selected",
    "admin.payoutMethods.methodAdded": "Payout method added",
    "admin.payoutMethods.operationFailed": "Operation failed",
    "admin.payoutMethods.methodUpdated": "Payout method updated",
    "admin.payoutMethods.methodDeleted": "Payout method deleted",
    "admin.payoutMethods.title": "Payout Methods Management",
    "admin.payoutMethods.subtitle": "View and manage all users' payout methods",
    "admin.payoutMethods.description": "View and manage all users' payout methods",
    "admin.payoutMethods.searchPlaceholder": "Search by username or email...",
    "admin.payoutMethods.filterByUserId": "Filter by User ID",
    "admin.payoutMethods.filterUserId": "Filter by User ID",
    "admin.payoutMethods.clear": "Clear",
    "admin.payoutMethods.notFound": "No Payout Method Found",
    "admin.payoutMethods.notFoundTitle": "No Payout Method Found",
    "admin.payoutMethods.noMethodForUser": "No payout method for this user",
    "admin.payoutMethods.noMethodsYet": "No payout methods added yet",
    "admin.payoutMethods.noMethodAddedYet": "No payout methods added yet",
    "admin.payoutMethods.addMethod": "Add Payout Method",
    "admin.payoutMethods.bankTransfer": "Bank Transfer",
    "admin.payoutMethods.default": "Default",
    "admin.payoutMethods.verified": "Verified",
    "admin.payoutMethods.pendingVerification": "Pending Verification",
    "admin.payoutMethods.pending": "Pending Verification",
    "admin.payoutMethods.notVerified": "Not Verified",
    "admin.payoutMethods.unverified": "Not Verified",
    "admin.payoutMethods.accountHolder": "Account Holder",
    "admin.payoutMethods.bank": "Bank",
    "admin.payoutMethods.bankLabel": "Bank",
    "admin.payoutMethods.country": "Country",
    "admin.payoutMethods.countryLabel": "Country",
    "admin.payoutMethods.currency": "Currency",
    "admin.payoutMethods.currencyLabel": "Currency",
    "admin.payoutMethods.paypalEmail": "PayPal Email",
    "admin.payoutMethods.lastUpdate": "Last update",
    "admin.payoutMethods.lastUpdated": "Last updated",
    "admin.payoutMethods.profile": "Profile",
    "admin.payoutMethods.revealFull": "Reveal Full",
    "admin.payoutMethods.editMethod": "Edit Payout Method",
    "admin.payoutMethods.addNewMethod": "Add New Payout Method",
    "admin.payoutMethods.addMethodTitle": "Add New Payout Method",
    "admin.payoutMethods.adminOtpNotice": "OTP verification is not required for admin changes. An email notification will be sent to the user.",
    "admin.payoutMethods.addEditDescription": "OTP verification is not required for admin changes. An email notification will be sent to the user.",
    "admin.payoutMethods.userId": "User ID *",
    "admin.payoutMethods.userIdLabel": "User ID *",
    "admin.payoutMethods.enterUserId": "Enter User ID",
    "admin.payoutMethods.userIdPlaceholder": "Enter User ID",
    "admin.payoutMethods.ibanLabel": "IBAN *",
    "admin.payoutMethods.accountHolderName": "Account Holder Name *",
    "admin.payoutMethods.accountHolderNameLabel": "Account Holder Name *",
    "admin.payoutMethods.fullName": "Full Name",
    "admin.payoutMethods.fullNamePlaceholder": "Full Name",
    "admin.payoutMethods.bankName": "Bank Name",
    "admin.payoutMethods.bankNameLabel": "Bank Name",
    "admin.payoutMethods.optional": "Optional",
    "admin.payoutMethods.optionalPlaceholder": "Optional",
    "admin.payoutMethods.paypalEmailLabel": "PayPal Email Address *",
    "admin.payoutMethods.update": "Update",
    "admin.payoutMethods.add": "Add",
    "admin.payoutMethods.fullPaymentInfo": "Full Payment Information",
    "admin.payoutMethods.fullPaymentDetails": "Full Payment Details",
    "admin.payoutMethods.auditLogNotice": "This information is being logged to the audit log.",
    "admin.payoutMethods.auditLogWarning": "This information is being logged to the audit log.",
    "admin.payoutMethods.sensitiveDataWarning": "This information is sensitive and your viewing has been logged.",
    "admin.payoutMethods.userLabel": "User",
    "admin.payoutMethods.user": "User",
    "admin.payoutMethods.bankInfo": "Bank Information",
    "admin.payoutMethods.bankDetails": "Bank Details",
    "admin.payoutMethods.ibanFull": "IBAN (FULL)",
    "admin.payoutMethods.accountHolderLabel": "Account Holder",
    "admin.payoutMethods.paypalInfo": "PayPal Information",
    "admin.payoutMethods.paypalDetails": "PayPal Details",
    "admin.payoutMethods.paypalEmailFull": "PayPal Email (FULL)",
    "admin.payoutMethods.statusVerified": "Verified",
    "admin.payoutMethods.statusPending": "Pending",
    "admin.payoutMethods.statusNotVerified": "Not Verified",
    "admin.payoutMethods.statusUnverified": "Not Verified",
    "admin.payoutMethods.statusUnverifiedText": "Not Verified",
    "admin.payoutMethods.statusLabel": "Status",
    "admin.payoutMethods.close": "Close",
    "admin.payoutMethods.deleteMethod": "Delete Payout Method",
    "admin.payoutMethods.deleteWarning": "This action cannot be undone and an email notification will be sent to the user.",
    "admin.payoutMethods.userColon": "User",
    "admin.payoutMethods.delete": "Delete",
    "admin.payoutMethods.billingPayoutProfile": "Billing & Payout Profile",
    "admin.payoutMethods.billingProfileTitle": "Billing & Payout Profile",
    "admin.payoutMethods.maskedDataNotice": "Sensitive data is masked for security.",
    "admin.payoutMethods.maskedDataWarning": "Sensitive data is masked for security.",
    "admin.payoutMethods.identityInfo": "A) Identity Information",
    "admin.payoutMethods.profileType": "Profile Type",
    "admin.payoutMethods.business": "Business / Company",
    "admin.payoutMethods.individual": "Individual",
    "admin.payoutMethods.legalName": "Legal Full Name",
    "admin.payoutMethods.displayName": "Display Name",
    "admin.payoutMethods.email": "Email",
    "admin.payoutMethods.phone": "Phone",
    "admin.payoutMethods.businessInfo": "Business Information",
    "admin.payoutMethods.companyName": "Company Name",
    "admin.payoutMethods.registrationNumber": "Company Registration No",
    "admin.payoutMethods.companyRegNo": "Company Registration No",
    "admin.payoutMethods.vatNumber": "VAT Number",
    "admin.payoutMethods.addressInfo": "B) Address Information",
    "admin.payoutMethods.city": "City",
    "admin.payoutMethods.stateRegion": "State/Region",
    "admin.payoutMethods.state": "State/Region",
    "admin.payoutMethods.postalCode": "Postal Code",
    "admin.payoutMethods.addressLine1": "Address Line 1",
    "admin.payoutMethods.addressLine2": "Address Line 2",
    "admin.payoutMethods.taxInfo": "C) Tax Information (Required for Payouts)",
    "admin.payoutMethods.taxStatus": "Tax Status",
    "admin.payoutMethods.taxMissing": "Missing (Cannot Withdraw)",
    "admin.payoutMethods.taxPersonal": "Individual",
    "admin.payoutMethods.personal": "Individual",
    "admin.payoutMethods.taxCorporate": "Corporate",
    "admin.payoutMethods.corporate": "Corporate",
    "admin.payoutMethods.taxCountry": "Tax Country",
    "admin.payoutMethods.taxIdMasked": "Tax / ID Number (Masked)",
    "admin.payoutMethods.taxWarning": "This user cannot create a withdrawal request without completing tax information",
    "admin.payoutMethods.activeMethod": "D) Active Payout Method",
    "admin.payoutMethods.method": "Method",
    "admin.payoutMethods.verificationStatus": "Verification Status",
    "admin.payoutMethods.ibanMasked": "IBAN (Masked)",
    "admin.payoutMethods.paypalMasked": "PayPal Email (Masked)",
    "admin.payoutMethods.updatedBy": "Updated by",
    "admin.payoutMethods.securityNotice": "Sensitive data (IBAN, Tax ID) is masked for security. Use the 'Reveal Full' button to see full details.",
    "admin.payoutMethods.revealIban": "Reveal Full (IBAN)",

    // changePassword
    "changePassword.title": "Change Password",
    "changePassword.description": "Please change your password for security.",
    "changePassword.currentPassword": "Current Password",
    "changePassword.newPassword": "New Password",
    "changePassword.confirmPassword": "New Password (Confirm)",
    "changePassword.showPasswords": "Show passwords",
    "changePassword.submitBtn": "Change Password",
    "changePassword.passwordsNotMatch": "New passwords do not match",
    "changePassword.passwordLength": "Password must be at least 6 characters",
    "changePassword.passwordChanged": "Password changed successfully",
    "changePassword.passwordChangeFailed": "Failed to change password",

    // suspended
    "suspended.title": "Account Suspended",
    "suspended.greeting": "Hello ",
    "suspended.reason": ", your account has been suspended due to license violation.",
    "suspended.restrictions": "Restrictions",
    "suspended.noUpload": "You cannot upload new releases",
    "suspended.noPayout": "You cannot request payouts",
    "suspended.noIban": "You cannot update IBAN information",
    "suspended.accessible": "Accessible Features",
    "suspended.viewReleases": "You can view your existing releases",
    "suspended.reviewHistory": "You can review your takedown and claim history",
    "suspended.createSupport": "You can create a support ticket",
    "suspended.contactSupport": "Please contact our support team to lift the suspension.",
    "suspended.contactBtn": "Support Ticket",
    "suspended.createTicketTitle": "Create Support Ticket",
    "suspended.ticketSubmitted": "Your request has been received!",
    "suspended.ticketTeamReply": "Our support team will get back to you as soon as possible.",
    "suspended.fillFields": "Please fill in all fields",
    "suspended.ticketCreated": "Support ticket created",
    "suspended.ticketFailed": "Failed to create ticket",
    "suspended.subjectPlaceholder": "E.g.: About account suspension status",
    "suspended.messagePlaceholder": "Why do you think your account was suspended? Explain your appeal in detail...",
    "suspended.catAccount": "Account / Appeal",
    "suspended.catTechnical": "Technical Issue",
    "suspended.catRelease": "Release Issue",
};

export default en;
